(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-address-input"] && !Shopify.designMode) return;
  try {
    // 确保只定义一次 address-input Web Component
  if (!customElements.get('address-input')) {
    customElements.define(
      'address-input',
      class AddressInput extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }

        init() {
          var self = this;

          // 确保所有下拉面板初始状态为隐藏
          var allPanels = this.querySelectorAll('.address-dropdown-panel');
          allPanels.forEach(function (panel) {
            panel.style.display = 'none';
          });

          var container = this.querySelector('.address_input_container');
          var input = this.querySelector('input.js-address-input-text');
          var select = this.querySelector('select');

          // 处理文本输入框
          if (input) {
            input.addEventListener('focus', function () {
              console.log('focus');

              var floatingField = input.closest('.floating-field');
              if (floatingField) {
                // 如果已经有错误状态（字段为空且必填），保持 error 状态
                if (
                  floatingField.getAttribute('data-status') === 'error' ||
                  floatingField.classList.contains('has-error')
                ) {
                  floatingField.setAttribute('data-status', 'error');
                } else {
                  floatingField.setAttribute('data-status', 'focus');
                }
              }
            });
            input.addEventListener('blur', function () {
              var floatingField = input.closest('.floating-field');
              if (floatingField) {
                // 检查是否有值来决定是否保持浮动状态
                if (input.value && input.value.trim().length > 0) {
                  floatingField.classList.add('is-filled');
                  floatingField.classList.remove('has-error');
                  floatingField.removeAttribute('data-status');
                } else {
                  floatingField.classList.remove('is-filled');
                  // 必填字段在输入为空时添加错误状态
                  if (floatingField.hasAttribute('data-required')) {
                    floatingField.classList.add('has-error');
                    container.classList.add('field-error');
                    floatingField.setAttribute('data-status', 'error');
                    // 显示错误消息
                    var errorMsg = floatingField.querySelector('.error-message');
                    if (errorMsg) {
                      errorMsg.style.display = 'block';
                    }
                  } else {
                    floatingField.removeAttribute('data-status');
                    // 隐藏错误消息
                    var errorMsg = floatingField.querySelector('.error-message');
                    if (errorMsg) {
                      errorMsg.style.display = 'none';
                    }
                  }
                }
              }
            });
            input.addEventListener('input', function () {
              var floatingField = input.closest('.floating-field');
              if (floatingField) {
                // 有内容时添加 is-filled 并移除错误状态
                if (input.value && input.value.trim().length > 0) {
                  floatingField.classList.add('is-filled');
                  floatingField.classList.remove('has-error');
                  container.classList.remove('field-error');
                  floatingField.classList.remove('has-error');
                  floatingField.removeAttribute('data-status');
                  // 隐藏错误消息
                  var errorMsg = floatingField.querySelector('.error-message');
                  if (errorMsg) {
                    errorMsg.style.display = 'none';
                  }
                } else {
                  floatingField.classList.remove('is-filled');
                  container.classList.add('field-error');
                  // 必填字段在输入为空时添加错误状态
                  if (floatingField.hasAttribute('data-required')) {
                    floatingField.classList.add('has-error');
                    floatingField.setAttribute('data-status', 'error');
                    // 显示错误消息
                    var errorMsg = floatingField.querySelector('.error-message');
                    if (errorMsg) {
                      errorMsg.style.display = 'block';
                    }
                  }
                }
              }
            });
          }

          // 处理下拉选择器
          if (select) {
            var isCountry = select.classList.contains('country-selector');
            var isProvince = select.classList.contains('province-selector');

            // 下拉框 blur 时验证必填
            select.addEventListener('blur', function () {
              var floatingField = select.closest('.floating-field');
              if (!floatingField) return;
              if (floatingField.hasAttribute('data-required')) {
                if (!select.value || select.value === '' || select.value === '---') {
                  floatingField.setAttribute('data-status', 'error');
                } else {
                  floatingField.removeAttribute('data-status');
                }
              }
            });

            // 选中选项时清除错误
            select.addEventListener('change', function () {
              var floatingField = select.closest('.floating-field');
              if (floatingField) {
                if (select.value && select.value !== '' && select.value !== '---') {
                  floatingField.removeAttribute('data-status');
                }
              }
            });

            if (isCountry) {
              this.initCountrySelect(select);
            } else if (isProvince) {
              this.initProvinceSelect(select);
            }
          }

          // 点击外部关闭下拉
          document.addEventListener('click', function (evt) {
            if (!self.contains(evt.target)) {
              self.closeDropdowns();
            }
          });
        }

        initCountrySelect(select) {
          var self = this;
          var optionsContainer = this.querySelector('[data-address-country-options]');
          var trigger = this.querySelector('.address-select-trigger-country');
          var panel = this.querySelector('.address-dropdown-panel-country');
          var floatingField = this.querySelector('.floating-field');

          if (!optionsContainer || !trigger || !select || !panel) return;

          // 清空选项容器
          optionsContainer.innerHTML = '';

          var currentLabel = '';
          var currentValue = '';
          var dataCountry = select.getAttribute('data-country') || '';
          var foundMatch = false;
          var matchedProvincesAttr = '';

          // 生成下拉选项
          for (var i = 0; i < select.options.length; i++) {
            var opt = select.options[i];
            var val = opt.value;
            var text = opt.textContent || opt.innerText || '';
            var provincesAttr = opt.getAttribute('data-provinces') || '';

            if (!val || val === '---') continue;

            var li = document.createElement('li');
            li.className = 'select-options-item';
            li.setAttribute('data-value', val);
            li.setAttribute('role', 'option');
            if (provincesAttr) {
              li.setAttribute('data-provinces', provincesAttr);
            }
            li.textContent = text;

            // 检查是否匹配预设值
            if (dataCountry && val === dataCountry) {
              foundMatch = true;
              currentValue = val;
              currentLabel = text;
              matchedProvincesAttr = provincesAttr;
            }

            optionsContainer.appendChild(li);
          }

          // 设置初始值
          if (foundMatch) {
            select.value = currentValue;
            var labelSpan = trigger.querySelector('.address-select-label');
            if (labelSpan) {
              labelSpan.textContent = currentLabel;
            }
            if (floatingField) {
              floatingField.classList.add('is-filled');
            }
            // 初始化省份选项
            self.updateProvinceOptions(matchedProvincesAttr);
          } else {
            // 如果没有预设值，选择第一个有效选项
            var firstOption = select.querySelector('option:not([value=""]):not([value="---"])');
            if (firstOption) {
              select.value = firstOption.value;
              var labelSpan = trigger.querySelector('.address-select-label');
              if (labelSpan) {
                labelSpan.textContent = firstOption.textContent;
              }
              if (floatingField) {
                floatingField.classList.add('is-filled');
              }
              var firstProvincesAttr = firstOption.getAttribute('data-provinces') || '';
              self.updateProvinceOptions(firstProvincesAttr);
            }
          }

          // 点击触发器展开/收起下拉
          trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            self.toggleDropdown(panel, trigger);
          });

          // 键盘导航支持
          trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              self.toggleDropdown(panel, trigger);
            } else if (e.key === 'Escape') {
              self.closeDropdowns();
            }
          });

          // 选项点击事件
          optionsContainer.addEventListener('click', function (evt) {
            var item = evt.target.closest('.select-options-item');
            if (!item) return;

            var val = item.getAttribute('data-value');
            var text = item.textContent ? item.textContent.trim() : '';
            var provincesAttr = item.getAttribute('data-provinces') || '';

            // 更新选择器和显示
            select.value = val;
            var labelSpan = trigger.querySelector('.address-select-label');
            if (labelSpan) {
              labelSpan.textContent = text;
            }

            if (floatingField) {
              floatingField.classList.add('is-filled');
            }

            // 触发change事件
            select.dispatchEvent(new Event('change', { bubbles: true }));

            // 更新省份选项
            self.updateProvinceOptions(provincesAttr);

            // 关闭下拉
            self.closeAllDropdowns();
          });
        }

        toggleDropdown(panel, trigger) {
          var isCurrentOpen = panel.style.display === 'block';

          // 先关闭所有下拉
          this.closeDropdowns();

          // 如果当前下拉之前是关闭的，则打开它
          if (!isCurrentOpen) {
            panel.style.display = 'block';
            trigger.classList.add('open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        }

        updateProvinceOptions(provincesAttr) {
          var form = this.closest('form') || this.closest('.address-form') || document;
          var provinceSelect = form.querySelector('.province-selector');
          var provinceTrigger = form.querySelector('.address-select-trigger-province');
          var provincePanel = form.querySelector('.address-dropdown-panel-province');
          var provinceOptionsContainer = form.querySelector('[data-address-province-options]');
          var provinceFloatingField = provinceTrigger ? provinceTrigger.closest('.floating-field') : null;
          // 查找 province-col 容器
          var provinceCol = provinceTrigger ? provinceTrigger.closest('.province-col') : null;

          if (!provinceSelect || !provinceTrigger || !provinceOptionsContainer) return;

          try {
            var provinces = provincesAttr ? JSON.parse(provincesAttr) : null;

            if (provinces && Array.isArray(provinces) && provinces.length > 0) {
              // 清空旧选项
              provinceSelect.innerHTML = '';
              provinceOptionsContainer.innerHTML = '';

              var provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');
              var originalProvince = provinceSelect.getAttribute('data-country_prov') || '';
              var selectedProvince = null;
              var firstProvince = null;

              // 生成省份选项
              for (var i = 0; i < provinces.length; i++) {
                var province = provinces[i];
                var code = province[0];
                var name = province[1];

                // 添加到原生select
                var option = document.createElement('option');
                option.value = code;
                option.textContent = name;
                provinceSelect.appendChild(option);

                // 添加到自定义下拉
                var li = document.createElement('li');
                li.className = 'select-options-item';
                li.setAttribute('data-value', code);
                li.setAttribute('role', 'option');
                li.textContent = name;
                provinceOptionsContainer.appendChild(li);

                if (i === 0) {
                  firstProvince = { code: code, name: name };
                }

                if (originalProvince && code === originalProvince) {
                  selectedProvince = { code: code, name: name };
                }
              }

              // 设置选中的省份
              var finalProvince = selectedProvince || firstProvince;
              if (finalProvince) {
                provinceSelect.value = finalProvince.code;
                if (provinceLabelSpan) {
                  provinceLabelSpan.textContent = finalProvince.name;
                }
              }

              // 显示省份选择器和容器
              if (provinceFloatingField) {
                provinceFloatingField.style.display = '';
                provinceFloatingField.classList.add('is-filled');
              }
              if (provinceCol) {
                provinceCol.style.display = '';
              }
              provinceTrigger.style.display = '';

              // 绑定省份选择事件
              this.bindProvinceEvents(
                provinceSelect,
                provinceTrigger,
                provincePanel,
                provinceOptionsContainer,
                provinceFloatingField
              );

              // 触发change事件
              provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              // 没有省份数据，隐藏省份选择器和容器
              provinceSelect.innerHTML = '';
              provinceOptionsContainer.innerHTML = '';
              provinceSelect.value = '';

              var provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');
              if (provinceLabelSpan) {
                provinceLabelSpan.textContent = '';
              }

              if (provinceFloatingField) {
                provinceFloatingField.style.display = 'none';
                provinceFloatingField.classList.remove('is-filled');
              }
              // 隐藏 province-col 容器
              if (provinceCol) {
                provinceCol.style.display = 'none';
              }
              provinceTrigger.style.display = 'none';
            }
          } catch (e) {
            console.error('解析省份数据失败:', e);
            if (provinceFloatingField) {
              provinceFloatingField.style.display = 'none';
            }
            // 出错时也隐藏 province-col 容器
            if (provinceCol) {
              provinceCol.style.display = 'none';
            }
            provinceTrigger.style.display = 'none';
          }
        }

        bindProvinceEvents(
          provinceSelect,
          provinceTrigger,
          provincePanel,
          provinceOptionsContainer,
          provinceFloatingField
        ) {
          var self = this;

          // 避免重复绑定事件
          if (provinceTrigger.hasAttribute('data-events-bound')) return;
          provinceTrigger.setAttribute('data-events-bound', 'true');

          // 点击触发器展开/收起下拉
          provinceTrigger.addEventListener('click', function (e) {
            e.stopPropagation();
            self.toggleDropdown(provincePanel, provinceTrigger);
          });

          // 选项点击事件
          provinceOptionsContainer.addEventListener('click', function (evt) {
            var item = evt.target.closest('.select-options-item');
            if (!item) return;

            var val = item.getAttribute('data-value');
            var text = item.textContent ? item.textContent.trim() : '';

            // 更新选择器和显示
            provinceSelect.value = val;
            var labelSpan = provinceTrigger.querySelector('.address-select-label');
            if (labelSpan) {
              labelSpan.textContent = text;
            }

            if (provinceFloatingField) {
              provinceFloatingField.classList.add('is-filled');
            }

            // 触发change事件
            provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));

            // 立即关闭省份下拉面板
            if (provincePanel) {
              provincePanel.style.display = 'none';
              provinceTrigger.classList.remove('open');
            }

            // 确保关闭所有下拉面板
            self.closeAllDropdowns();
          });
        }

        initProvinceSelect(select) {
          // 省份选择器通过 updateProvinceOptions 方法初始化
          // 但在初始化时，如果没有对应的国家选择器或国家未选择，需要隐藏 province-col
          var form = this.closest('form') || this.closest('.address-form') || document;
          var countrySelect = form.querySelector('.country-selector');
          var provinceTrigger = form.querySelector('.address-select-trigger-province');
          var provinceCol = provinceTrigger ? provinceTrigger.closest('.province-col') : null;

          // 如果没有国家选择器，或者国家选择器没有值，隐藏省份列
          if (!countrySelect || !countrySelect.value || countrySelect.value === '' || countrySelect.value === '---') {
            if (provinceCol) {
              provinceCol.style.display = 'none';
            }
            if (provinceTrigger) {
              provinceTrigger.style.display = 'none';
            }
          }
        }

        closeDropdowns() {
          // 关闭当前组件内的所有下拉面板
          var panels = this.querySelectorAll('.address-dropdown-panel');
          panels.forEach(function (panel) {
            panel.style.display = 'none';
          });

          // 移除所有触发器的 open 状态并更新 aria-expanded
          var triggers = this.querySelectorAll('.address-select-trigger');
          triggers.forEach(function (trigger) {
            trigger.classList.remove('open');
            trigger.setAttribute('aria-expanded', 'false');
          });
        }

        closeAllDropdowns() {
          // 关闭当前组件内的所有下拉面板
          this.closeDropdowns();

          // 同时查找表单中的所有下拉面板（防止跨组件的面板没有关闭）
          var form = this.closest('form');
          if (form) {
            var formPanels = form.querySelectorAll('.address-dropdown-panel');
            formPanels.forEach(function (panel) {
              panel.style.display = 'none';
            });
            var formTriggers = form.querySelectorAll('.address-select-trigger');
            formTriggers.forEach(function (trigger) {
              trigger.classList.remove('open');
              trigger.setAttribute('aria-expanded', 'false');
            });
          }

          // 查找页面中所有的地址下拉面板
          var allPanels = document.querySelectorAll('.address-dropdown-panel');
          allPanels.forEach(function (panel) {
            panel.style.display = 'none';
          });
          var allTriggers = document.querySelectorAll('.address-select-trigger');
          allTriggers.forEach(function (trigger) {
            trigger.classList.remove('open');
            trigger.setAttribute('aria-expanded', 'false');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-address-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('address-popup')) {
      customElements.define(
        'address-popup',
        class AddressPopup extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            // 返回按钮点击事件 - 关闭弹窗
            var backBtn = this.querySelector('.account-address-popup-back-btn');
            if (backBtn) {
              backBtn.addEventListener('click', () => {
                this.closePopup();
              });
            }
          }

          /**
           * 关闭弹窗方法 - 与 address_cancel 按钮行为一致
           * 隐藏弹窗、重置表单、启用滚动、清空错误状态
           */
          closePopup() {
            const _this = this;
            // 查找最近的 .address-popup 父元素（弹窗容器）
            const popupContainer = this.closest('.address-popup');
            if (popupContainer) {
              // 隐藏弹窗
              popupContainer.style.zIndex = '-99';
              popupContainer.style.opacity = '0';

              document.querySelectorAll('.field-error').forEach((el) => {
                el.classList.remove('field-error');
              });
              document.querySelectorAll('.is-filled').forEach((el) => {
                el.classList.remove('is-filled');
              });
              // 重置表单
              const form = popupContainer.querySelector('form');
              if (form) {
                form.reset();

                // 重置自定义下拉的显示文本
                const countrySelect = form.querySelector('.country-selector');
                if (countrySelect) {
                  const dataCountry = countrySelect.getAttribute('data-country');
                  if (dataCountry && dataCountry !== '---' && dataCountry.trim() !== '') {
                    countrySelect.value = dataCountry;
                    countrySelect.dispatchEvent(new Event('change', { bubbles: true }));

                    // 重置国家下拉的显示文本
                    const countryTrigger = form.querySelector('.address-select-trigger-country');
                    if (countryTrigger) {
                      const countryLabelSpan = countryTrigger.querySelector('.address-select-label');
                      if (countryLabelSpan) {
                        // 从 select 的 options 中查找对应的文本
                        for (let i = 0; i < countrySelect.options.length; i++) {
                          if (countrySelect.options[i].value === dataCountry) {
                            countryLabelSpan.textContent = countrySelect.options[i].textContent || '';
                            break;
                          }
                        }
                      }
                    }
                  }
                }

                // 重置省份下拉的显示文本
                const provinceSelect = form.querySelector('.province-selector');
                const provinceTrigger = form.querySelector('.address-select-trigger-province');
                const provinceContainer = provinceTrigger ? provinceTrigger.closest('.address_input_container') : null;

                if (provinceSelect && provinceTrigger) {
                  const dataProvince = provinceSelect.getAttribute('data-country_prov');

                  // 如果有原始省份数据，需要恢复显示
                  if (dataProvince && dataProvince !== '---' && dataProvince.trim() !== '') {
                    // 检查原始国家是否有省份数据
                    const dataCountry = countrySelect ? countrySelect.getAttribute('data-country') : null;
                    if (dataCountry) {
                      // 从国家的 options 中查找对应的省份数据
                      const countryOptions = countrySelect.options;
                      let provincesAttr = null;
                      for (let j = 0; j < countryOptions.length; j++) {
                        if (countryOptions[j].value === dataCountry) {
                          provincesAttr = countryOptions[j].getAttribute('data-provinces');
                          break;
                        }
                      }

                      if (provincesAttr) {
                        try {
                          const provinces = JSON.parse(provincesAttr);
                          if (provinces && Array.isArray(provinces) && provinces.length > 0) {
                            // 原始国家有省份数据，恢复省份选择器
                            // 清空旧选项
                            provinceSelect.innerHTML = '';
                            const provinceOptionsContainer = form.querySelector('[data-address-province-options]');
                            if (provinceOptionsContainer) {
                              provinceOptionsContainer.innerHTML = '';
                            }

                            // 生成省份选项
                            const provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');
                            let foundProvince = false;

                            for (let i = 0; i < provinces.length; i++) {
                              const province = provinces[i];
                              const code = province[0];
                              const name = province[1];

                              // 添加到原生 select
                              const option = document.createElement('option');
                              option.value = code;
                              option.textContent = name;
                              provinceSelect.appendChild(option);

                              // 添加到自定义下拉列表
                              if (provinceOptionsContainer) {
                                const li = document.createElement('li');
                                li.className = 'select-options-item';
                                li.setAttribute('data-value', code);
                                li.textContent = name;
                                provinceOptionsContainer.appendChild(li);
                              }

                              // 如果匹配原始省份值，设置为选中
                              if (code === dataProvince) {
                                provinceSelect.value = code;
                                if (provinceLabelSpan) {
                                  provinceLabelSpan.textContent = name;
                                }
                                foundProvince = true;
                              }
                            }

                            // 如果没有找到匹配的省份，选择第一个
                            if (!foundProvince && provinces.length > 0) {
                              const firstProvince = provinces[0];
                              provinceSelect.value = firstProvince[0];
                              if (provinceLabelSpan) {
                                provinceLabelSpan.textContent = firstProvince[1];
                              }
                            }

                            // 显示省份 trigger 和容器
                            if (provinceContainer) {
                              provinceContainer.style.display = '';
                            }
                            provinceTrigger.style.display = '';

                            // 触发 change 事件
                            provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
                          }
                        } catch (e) {
                          console.error('解析省份数据失败:', e);
                        }
                      }
                    }
                  }
                }
              }

              // 启用滚动
              if (window.litime && typeof window.litime.enableScroll === 'function') {
                window.litime.enableScroll();
              }

              // 清空所有必填字段的错误状态
              const requiredFields = popupContainer.querySelectorAll('[required]');
              requiredFields.forEach((field) => {
                const container = field.closest('.address_input_container');
                const floatingField = container ? container.closest('.floating-field') : null;
                const errorEl = container ? container.parentElement.querySelector('.error-message') : null;
                const placeholder = container ? container.querySelector('.address_input_placeholder') : null;

                if (floatingField) {
                  floatingField.removeAttribute('data-status');
                  floatingField.classList.remove('is-focus');
                  floatingField.classList.remove('is-filled');
                }
                if (errorEl) {
                  errorEl.style.display = 'none';
                }
                if (placeholder) {
                  placeholder.style.color = '#666666';
                  placeholder.style.top = '';
                  placeholder.style.transform = '';
                  placeholder.style.fontSize = '';
                }
              });

              // 恢复保存按钮的 loading / 文案状态
              const submitBtn = popupContainer.querySelector('.addr-btn--primary');
              if (submitBtn) {
                const textEl = submitBtn.querySelector('.addr-loading-text-text');
                const iconEl = submitBtn.querySelector('.addr-loading-text-icon');
                if (textEl) textEl.classList.remove('hidden');
                if (iconEl) iconEl.classList.add('hidden');
              }

              // 重新初始化所有 address-input 组件，恢复到原始状态
              setTimeout(function () {
                const addressInputs = popupContainer.querySelectorAll('address-input');
                addressInputs.forEach(function (inputComponent) {
                  if (inputComponent && typeof inputComponent.updateFilledState === 'function') {
                    inputComponent.updateFilledState();
                  }
                });
              }, 50);
            }
          }

          init() {
            // 仅在本弹窗内处理必填校验的红色占位与边框（不依赖全局脚本）
            const forms = document.querySelectorAll('.addr-form form');
            forms.forEach((form) => {
              const submitBtn = form.querySelector('.addr-btn--primary');
              const cancelBtn = form.querySelector('.address_cancel');
              if (!submitBtn) return;

              // 单个字段校验函数
              const validateField = (field) => {
                let isValid = true;
                let errorEl = null;
                let floatingField = null;

                // 尝试多种方式获取 floating-field-address 和 error-message
                // 方法1: 通过 address-input Web Component
                const addressInput = field.closest('address-input');
                if (addressInput) {
                  floatingField = addressInput.querySelector('.floating-field');
                  errorEl = addressInput.querySelector('.error-message');
                }
                
                // 方法2: 直接查找
                if (!floatingField) {
                  floatingField = field.closest('.floating-field');
                }
                if (!errorEl && floatingField) {
                  errorEl = floatingField.querySelector('.error-message');
                }

                const value = field.value && field.value.trim();
                
                if (!value) {
                  isValid = false;
                  if (floatingField) floatingField.setAttribute('data-status', 'error');
                } else {
                  if (floatingField) floatingField.removeAttribute('data-status');
                }
                
                return isValid;
              };

              // 为所有必填字段添加 blur 事件监听
              const requiredFields = form.querySelectorAll('[required]');
              requiredFields.forEach((field) => {
                field.addEventListener('blur', () => {
                  validateField(field);
                });
              });

              const handleValidate = (e) => {
                let isValid = true;
                const requiredFields = form.querySelectorAll('[required]');
                requiredFields.forEach((field) => {
                  if (!validateField(field)) {
                    isValid = false;
                  }
                });

                if (!isValid) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }

                // 通过校验后：切换为 loading 态（文字隐藏，loading 显示）
                const loadingTextWrap = submitBtn.querySelector('.addr-loading-text');
                const textEl = submitBtn.querySelector('.addr-loading-text-text');
                const iconEl = submitBtn.querySelector('.addr-loading-text-icon');

                // 给按钮添加 loading class
                submitBtn.classList.add('loading');

                if (loadingTextWrap) {
                  if (textEl) textEl.classList.add('hidden');
                  if (iconEl) iconEl.classList.remove('hidden');
                }
              };

              submitBtn.addEventListener('click', handleValidate, { passive: false });

              // 点击取消时，关闭弹窗（与返回按钮行为一致）
              if (cancelBtn) {
                cancelBtn.addEventListener('click', () => {
                  this.closePopup();
                });
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-order-detail"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('account-order-detail')) {
      customElements.define(
        'account-order-detail',
        class AccountOrderDetail extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initBack();
            this.initCopy();
            this.initOpenTrack();
          }
          initBack() {
            var backHandler = function () {
              window.pq.eventBus.publish('account:switchTab', 'orders');
              window.pq.eventBus.publish('account:updataOrdersTab', 'all');
            };
            var headerBack = this.querySelector('.account-order-detail__header-back-wrapper');
            if (headerBack) headerBack.addEventListener('click', backHandler);
            var mainHeaderBack = this.querySelector('.account-order-detail__main-header-back-wrapper');
            if (mainHeaderBack) mainHeaderBack.addEventListener('click', backHandler);
          }
          initCopy() {
            const copy = this.querySelectorAll('[data-action="copy"]');
            copy.forEach((item) => {
              item.addEventListener('click', () => {
                if (window.pq && window.pq.copyToClipboard) {
                  window.pq.copyToClipboard(item.getAttribute('data-copy-text'));
                } else if (navigator.clipboard && navigator.clipboard.writeText) {
                  navigator.clipboard.writeText(item.getAttribute('data-copy-text')).catch(() => {});
                  if (window.pqToast && typeof window.pqToast.showToast === 'function') {
                    window.pqToast.showToast('success', (window.i18n && window.i18n.copy_success) || 'Copy success');
                  }
                }
              });
            });
          }
          initOpenTrack() {
            const openTrack = this.querySelectorAll('[data-action="open-track"]');
            openTrack.forEach((item) => {
              item.addEventListener('click', () => {
                this.querySelector('account-order-track').open(item.getAttribute('data-track'));
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-order-track"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('account-order-track')) {
      customElements.define(
        'account-order-track',
        class AccountOrderTrack extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initClose();
            this.initTabs();
            this.initCopy();
            this.initTrack();
          }
          initTrack() {
            const tracks = this.querySelectorAll('.account-order-track__tab-content-track-content');
            tracks.forEach((track) => {
              this.initTrackSingle(track.getAttribute('data-track'));
            });
          }
          open(track) {
            this.setAttribute('data-show', 'true');
            if (window.pq && typeof window.pq.scrollDisable === 'function') {
              window.pq.scrollDisable();
            }
            if (track) {
              this.switchTab(track);
            } else {
              this.switchTab(this.getAttribute('data-first-track'));
            }
          }
          initTrackSingle(track) {
            // 887324513746 测试
            let idAppend = '';
            if (this.getAttribute('data-type')) {
              idAppend = '-' + this.getAttribute('data-type');
            }
            let orderId = this.getAttribute('data-order-id');
            YQV5.trackSingle({
              YQ_ContainerId: `track-${orderId}-${track}${idAppend}`,
              YQ_Height: 300,
              YQ_Fc: '0',
              YQ_Num: track,
              YQ_RmAD: true,
              YQ_RmHeader: true,
              YQ_RmLink: true,
            });
          }
          initCopy() {
            const copies = this.querySelectorAll('.account-order-track__tab-content-track-header-content-copy');
            copies.forEach((copy) => {
              copy.addEventListener('click', () => {
                if (window.pq && window.pq.copyToClipboard) {
                  window.pq.copyToClipboard(copy.getAttribute('data-copy-text'));
                } else if (navigator.clipboard && navigator.clipboard.writeText) {
                  navigator.clipboard.writeText(copy.getAttribute('data-copy-text')).catch(() => {});
                  if (window.pqToast && typeof window.pqToast.showToast === 'function') {
                    window.pqToast.showToast('success', (window.i18n && window.i18n.copy_success) || 'Copy success');
                  }
                }
              });
            });
          }
          initTabs() {
            const tabs = this.querySelectorAll('.account-order-track__tab-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.switchTab(tab.getAttribute('data-tab'));
              });
            });
          }
          switchTab(tab) {
            const tabs = this.querySelectorAll('.account-order-track__tab-item');
            tabs.forEach((t) => t.setAttribute('data-active', 'false'));
            const tabItem = this.querySelector(`.account-order-track__tab-item[data-tab="${tab}"]`);
            tabItem.setAttribute('data-active', 'true');
            const contents = this.querySelectorAll('.account-order-track__tab-content');
            contents.forEach((content) => content.setAttribute('data-active', 'false'));
            const content = this.querySelector(`.account-order-track__tab-content[data-tab="${tab}"]`);
            content.setAttribute('data-active', 'true');
            this.setAttribute('data-current-track', tab);
            let offset = 24;
            const tabBox = this.querySelector('.account-order-track__tab');
            const tabRect = tabItem.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - offset;
            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initClose() {
            this.querySelector('.account-order-track__header-close').addEventListener('click', () => {
              this.close();
            });
          }
          close() {
            this.setAttribute('data-show', 'false');
            if (window.pq && typeof window.pq.enableScroll === 'function') {
              window.pq.enableScroll();
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-orders"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('account-orders')) {
      customElements.define(
        'account-orders',
        class AccountOrders extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            if (window.pq && typeof window.pq.onVisibleOnce === 'function') {
              window.pq.onVisibleOnce(this, () => {
                this.init();
              });
            } else {
              this.init();
            }
            window.pq.eventBus.subscribe('account:updateReviewPoints', (pointTasks) => {
              this.initPoints(pointTasks);
            });
            window.pq.eventBus.subscribe('account:updataOrdersTab', (tab) => {
              this.switchTab(tab);
            });
          }
          init() {
            this.initTabs();

            this.initExtend();
            this.initReview();
            this.initBack();
            this.initViewDetail();
            this.initViewTracking();
          }
          initViewTracking() {
            this.querySelectorAll('.account-orders__list-item-content-products-group-view').forEach((item) => {
              item.addEventListener('click', async (event) => {
                // 先if判断body中是否有和data-order-id相同的account-order-track，如果有则直接打开，如果没有则继续执行
                const orderTrackingItem = document.querySelector(
                  `.body-account-order-track[data-order-id="${item.getAttribute('data-order-id')}"]`
                );
                if (orderTrackingItem) {
                  orderTrackingItem.open(item.getAttribute('data-tracking-number'));
                  return;
                }
                if (item.getAttribute('data-loading') == 'true') {
                  return;
                }
                try {
                  item.setAttribute('data-loading', 'true');
                  const orderUrl = item.getAttribute('data-order-url');
                  await fetch(`${orderUrl}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const orderTrackingItem = html.querySelector('account-order-track');
                      // 增加一个class名
                      console.log('orderTrackingItem', orderTrackingItem);
                      orderTrackingItem.classList.add('body-account-order-track');
                      orderTrackingItem.setAttribute('data-type', 'body');
                      // 批量修改id，获取现有id，在id后面加上-body
                      const tracks = orderTrackingItem.querySelectorAll(
                        '.account-order-track__tab-content-track-content'
                      );
                      tracks.forEach((track) => {
                        const id = track.getAttribute('id');
                        if (id) {
                          track.setAttribute('id', id + '-body');
                        }
                      });
                      // 插入到body的最后面
                      document.body.appendChild(orderTrackingItem);
                      orderTrackingItem.open(item.getAttribute('data-tracking-number'));
                    });
                } catch (error) {
                  console.log('account-orders initViewTracking error', error);
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          initViewDetail() {
            this.querySelectorAll(
              '.account-orders__list-item-content-footer-view, .account-orders__list-item-mobile-footer-item-view'
            ).forEach((item) => {
              item.addEventListener('click', async (event) => {
                if (item.getAttribute('data-loading') == 'true') {
                  return;
                }
                try {
                  item.setAttribute('data-loading', 'true');
                  const orderUrl = item.getAttribute('data-order-url');
                  await fetch(`${orderUrl}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      // 替换this元素的父级有一个pq-account，这个dom中的pq-account__right-item[data-tab="order-detail"]的dom
                      const mainCustomersAccountNew = this.closest('pq-account');
                      const orderDetailItem = mainCustomersAccountNew.querySelector(
                        '.pq-account__right-item[data-tab="order-detail"]'
                      );
                      orderDetailItem.innerHTML = html.querySelector('account-order-detail').outerHTML;
                      window.pq.eventBus.publish('account:switchTab', 'orders');
                      //  修改orderDetailItem为显示状态，并且将所有pq-account__right-item改为false，然后修改pq-account__right-item[data-tab="order-detail"]的data-active为true
                      mainCustomersAccountNew.querySelectorAll('.pq-account__right-item').forEach((item) => {
                        item.setAttribute('data-active', 'false');
                      });
                      orderDetailItem.setAttribute('data-active', 'true');
                      window.pq.eventBus.publish('account:updateBreadcrumb', 'order-detail');
                      // 同时修改浏览页路由，格式为orderUrl，类似https://dev-askstarry.myshopify.com/account/orders/d807e8da0afe72fc3078c7205bec2efb
                      window.history.replaceState({}, '', orderUrl);
                      window.scrollTo(0, 0);
                    });
                } catch (error) {
                  console.log('account-orders initViewDetail error', error);
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          initBack() {
            this.querySelector('.account-orders__header-back').addEventListener('click', () => {
              window.pq.eventBus.publish('account:switchTab', 'overview');
            });
          }
          initPoints(pointTasks) {
            const points = this.querySelectorAll('.account-orders__list-item-content-products-item-review-points');
            const pointTask = pointTasks.find((item) => item.taskType == 6);
            if (pointTask && pointTask.point > 0) {
              points.forEach((point) => {
                point.setAttribute('data-show', 'true');
                point.querySelector(
                  '.account-orders__list-item-content-products-item-review-points-value'
                ).textContent = pointTask.point;
              });
            }
          }
          initTabs() {
            const tabs = this.querySelectorAll('.account-orders__tab-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                tabs.forEach((t) => t.setAttribute('data-active', 'false'));
                tab.setAttribute('data-active', 'true');
                const contents = this.querySelectorAll('.account-orders__tab-content');
                contents.forEach((content) => content.setAttribute('data-active', 'false'));
                const currentContent = this.querySelector(
                  `.account-orders__tab-content[data-tab="${tab.getAttribute('data-tab')}"]`
                );
                currentContent.setAttribute('data-active', 'true');
                // 同时滚动到到tabs距离左边的32px，保证点击时完全显示出来
                let offset = 32;
                if (window.innerWidth <= 576) {
                  offset = 16;
                }
                const tabBox = this.querySelector('.account-orders__tab');
                const tabRect = tab.getBoundingClientRect();
                const boxRect = tabBox.getBoundingClientRect();
                const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - offset;
                tabBox.scrollTo({
                  left: targetScroll,
                  behavior: 'smooth',
                });
              });
            });
          }
          switchTab(tab) {
            const tabs = this.querySelectorAll('.account-orders__tab-item');
            tabs.forEach((t) => t.setAttribute('data-active', 'false'));
            const tabItem = this.querySelector(`.account-orders__tab-item[data-tab="${tab}"]`);
            tabItem.setAttribute('data-active', 'true');
            const contents = this.querySelectorAll('.account-orders__tab-content');
            contents.forEach((content) => content.setAttribute('data-active', 'false'));
            const content = this.querySelector(`.account-orders__tab-content[data-tab="${tab}"]`);
            content.setAttribute('data-active', 'true');
            let offset = 32;
            if (window.innerWidth <= 576) {
              offset = 16;
            }
            const tabBox = this.querySelector('.account-orders__tab');
            const tabRect = tabItem.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - offset;
            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initExtend() {
            this.querySelectorAll('.account-orders__list-item-more').forEach((btn) => {
              btn.addEventListener('click', () => {
                const listItem = btn.closest('.account-orders__list-item');
                const products = listItem.querySelector('.account-orders__list-item-content-products');

                const isOpen = listItem.getAttribute('data-extend') === 'true';
                listItem.setAttribute('data-extend', String(!isOpen));

                if (!isOpen) {
                  // ===== 展开 =====
                  products.style.height = 'auto';
                  const height = products.scrollHeight;

                  products.style.height = '0';
                  products.offsetHeight; // 强制 reflow

                  products.style.height = height + 'px';

                  // 动画结束后释放高度
                  products.addEventListener(
                    'transitionend',
                    () => {
                      if (listItem.getAttribute('data-extend') === 'true') {
                        products.style.height = 'auto';
                      }
                    },
                    { once: true }
                  );
                } else {
                  // ===== 收起 =====
                  const height = products.scrollHeight;
                  products.style.height = height + 'px';

                  products.offsetHeight; // reflow
                  products.style.height = '0';
                }
              });
            });
          }
          initReview() {
            this.querySelectorAll('.account-orders__list-item-content-products-item-review-button').forEach((btn) => {
              btn.addEventListener('click', () => {
                const productId = btn.getAttribute('product-id');
                let reviewId;
                switch (Shopify.shop) {
                  case 'dev-askstarry.myshopify.com':
                    // 新开页面
                    // reviewId = '5g9kzMkFjL';
                    // window.open(`https://loox.io/review-items/${reviewId}`, '_blank');
                    reviewId = 'ddf8da7e-1598-46af-9dad-172294e4196c';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'litime-us.myshopify.com':
                    // US
                    reviewId = '566a5e93-4d26-4b9c-be5e-534a3bd327a9';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'litime-2.myshopify.com':
                    // CA
                    reviewId = '38f2ef47-cd48-4b68-b501-27ac73de2f0d';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'litime-de.myshopify.com':
                    // DE
                    reviewId = 'c71a11c6-d74e-41f9-9d1a-3efa8f8ea150';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;

                  case 'db6773.myshopify.com':
                    // JP
                    reviewId = '41lcB_945a';
                    window.open(`https://loox.io/review-items/${reviewId}`, '_blank');
                    break;
                  case 'fc7982-5.myshopify.com':
                    // AU
                    reviewId = 'b7ff1511-bc99-4e8d-95c8-7e8808a9da04';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case '4e91b4-ff.myshopify.com':
                    // IT
                    reviewId = '27a27da6-d794-4fb0-9882-03d9289f9434';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  // case 'litime-uk.myshopify.com':
                  //   // UK
                  //   break;
                  // case 'c010a7-c0.myshopify.com':
                  //   // FR
                  //   break;
                  // case '5141dc-dd.myshopify.com':
                  //   // ES
                  //   break;
                }
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-profile"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('account-profile')) {
      customElements.define(
        'account-profile',
        class AccountProfile extends HTMLElement {
          constructor() {
            super();
            // 获取 country.json 的 URL
            this.countryJsonUrl = window.accountProfileCountryJsonUrl || '';
            this.countryData = null;
          }
          connectedCallback() {
            this.init();
          }
          // 加载国家数据
          loadCountryData() {
            var self = this;
            return new Promise(function (resolve, reject) {
              if (self.countryData) {
                resolve(self.countryData);
                return;
              }
              fetch(self.countryJsonUrl)
                .then(function (response) {
                  if (!response.ok) {
                    throw new Error(
                      (window.pqI18n && window.pqI18n.failed_to_load_country_data) || 'Failed to load country data'
                    );
                  }
                  return response.json();
                })
                .then(function (data) {
                  self.countryData = data;
                  resolve(data);
                })
                .catch(function (error) {
                  console.error('Error loading country data:', error);
                  reject(error);
                });
            });
          }

          // 初始化国家下拉选项
          initCountryDropdown(section) {
            var self = this;
            var countryList = section.querySelector('[data-country-list]');
            var alphabetNav = section.querySelector('[data-country-alphabet-nav]');
            var countryTrigger = section.querySelector('[data-country-trigger]');
            var countryPanel = section.querySelector('[data-country-panel]');
            if (!countryList || !countryTrigger || !countryPanel) return;

            // 提前找到滚动容器
            var listContainer = countryList.parentElement;
            if (!listContainer || !listContainer.classList.contains('account-dropdown-list-container')) {
              listContainer = countryList.closest('.account-dropdown-list-container');
            }

            // 独立的下拉菜单显示/隐藏逻辑
            var isOpen = false;
            var toggleDropdown = function (skipResetSearch) {
              if (isOpen) {
                countryPanel.classList.remove('is-open');
                countryTrigger.classList.remove('open');
                isOpen = false;

                // 关闭下拉菜单时，恢复所有国家显示（不清空搜索框内容，因为已选中的国家名应该保留）
                if (!skipResetSearch) {
                  allCountryItems.forEach(function (item) {
                    item.style.display = '';
                  });
                  if (alphabetNav) {
                    alphabetNav.style.display = '';
                  }
                }
              } else {
                countryPanel.classList.add('is-open');
                countryTrigger.classList.add('open');
                isOpen = true;
              }
            };

            // 获取搜索 input 元素
            var searchInput = countryTrigger.querySelector('.account-country-search-input');
            var allCountryItems = []; // 存储所有国家选项，用于搜索过滤
            var panelMouseDown = false; // 标记是否在 panel 内 mousedown，避免点击字母导航时 blur 误关下拉

            // 初始化 selectedCountryName（从 input 的当前值获取）
            if (!countryTrigger.dataset.selectedCountryName && searchInput) {
              countryTrigger.dataset.selectedCountryName = searchInput.value || '';
            }

            // panel 内 mousedown 时设置标记，blur 时若在 panel 内点击则不关闭
            countryPanel.addEventListener('mousedown', function () {
              panelMouseDown = true;
            });

            // 点击 trigger 显示/隐藏下拉菜单
            countryTrigger.addEventListener('click', function (e) {
              if (countryTrigger.disabled) return;
              // 如果点击的是 input 元素，不切换下拉菜单
              if (e.target === searchInput) return;
              e.preventDefault();
              e.stopPropagation();
              toggleDropdown();
            });

            // 搜索 input 获得焦点时打开下拉菜单
            if (searchInput) {
              searchInput.addEventListener('focus', function (e) {
                if (countryTrigger.disabled || searchInput.readOnly) return;
                if (!isOpen) {
                  toggleDropdown();
                }
              });

              // 搜索 input 失去焦点时恢复默认值或清空
              searchInput.addEventListener('blur', function (e) {
                // 延迟执行，以便点击选项时能够正常选择
                setTimeout(function () {
                  // 若 blur 是由点击 panel 内（如字母导航）引起，则不关闭下拉
                  if (panelMouseDown) {
                    panelMouseDown = false;
                    return;
                  }
                  // 先关闭下拉菜单
                  if (isOpen) {
                    toggleDropdown();
                  }

                  // 获取已保存的国家名称
                  var savedCountryName = countryTrigger.dataset.selectedCountryName || '';

                  // 如果有原本选中的国家，恢复到原本的国家
                  if (savedCountryName) {
                    searchInput.value = savedCountryName;
                  } else {
                    // 如果没有原本选中的国家，清空输入框
                    searchInput.value = '';
                    countryTrigger.dataset.value = '';
                  }

                  // 恢复所有国家显示
                  allCountryItems.forEach(function (item) {
                    item.style.display = '';
                  });
                  if (alphabetNav) {
                    alphabetNav.style.display = '';
                  }
                }, 200);
              });

              // 搜索 input 输入事件：过滤国家列表
              searchInput.addEventListener('input', function (e) {
                var searchTerm = searchInput.value.toLowerCase().trim();

                // 过滤所有国家选项
                allCountryItems.forEach(function (item) {
                  var countryName = item.textContent.toLowerCase();
                  if (searchTerm === '' || countryName.indexOf(searchTerm) !== -1) {
                    item.style.display = '';
                  } else {
                    item.style.display = 'none';
                  }
                });

                // 如果搜索框为空，重新显示所有国家和字母表导航
                if (searchTerm === '') {
                  if (alphabetNav) {
                    alphabetNav.style.display = '';
                  }
                } else {
                  // 有搜索内容时，隐藏字母表导航
                  if (alphabetNav) {
                    alphabetNav.style.display = 'none';
                  }
                }
              });

              // 阻止 input 的点击事件冒泡，避免触发 trigger 的点击事件
              searchInput.addEventListener('click', function (e) {
                e.stopPropagation();
                if (!isOpen && !countryTrigger.disabled && !searchInput.readOnly) {
                  toggleDropdown();
                }
              });
            }

            // 点击选项后更新显示并关闭下拉菜单
            var handleCountrySelect = function (item) {
              var value = item.getAttribute('data-value');
              var text = item.textContent.trim();

              // 保存选中的国家名称到 dataset
              countryTrigger.dataset.selectedCountryName = text;

              // 更新 trigger 显示（input 元素）
              if (searchInput) {
                searchInput.value = text;
              }
              countryTrigger.dataset.value = value;

              var field = countryTrigger.closest('.floating-field');
              if (field) {
                field.classList.remove('field-error');
              }

              // 清空搜索，显示所有国家
              if (searchInput) {
                searchInput.value = text; // 保留选中的国家名称
              }
              allCountryItems.forEach(function (item) {
                item.style.display = '';
              });
              if (alphabetNav) {
                alphabetNav.style.display = '';
              }

              // 关闭下拉菜单
              toggleDropdown();
            };

            // 点击外部关闭下拉菜单
            var handleClickOutside = function (e) {
              if (isOpen && !countryPanel.contains(e.target) && !countryTrigger.contains(e.target)) {
                toggleDropdown();
              }
            };
            document.addEventListener('click', handleClickOutside);

            this.loadCountryData()
              .then(function (countries) {
                // 清空现有选项
                countryList.innerHTML = '';
                // 按国家名称排序
                var sortedCountries = countries.slice().sort(function (a, b) {
                  return a.country.localeCompare(b.country);
                });

                // 生成字母表导航
                if (alphabetNav) {
                  alphabetNav.innerHTML = '';
                  var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
                  var availableLetters = new Set();

                  // 收集所有可用的首字母
                  sortedCountries.forEach(function (country) {
                    var firstLetter = country.country.charAt(0).toUpperCase();
                    if (alphabet.includes(firstLetter)) {
                      availableLetters.add(firstLetter);
                    }
                  });

                  // 生成字母表导航项（只显示有对应国家的字母）
                  alphabet.forEach(function (letter) {
                    // 如果该字母没有对应的国家，直接跳过，不显示
                    if (!availableLetters.has(letter)) {
                      return;
                    }

                    var navItem = document.createElement('div');
                    navItem.className = 'account-dropdown-alphabet-nav-item';
                    navItem.textContent = letter;
                    navItem.setAttribute('data-letter', letter);

                    navItem.addEventListener('click', function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation(); // 阻止所有事件传播

                      // 移除其他 active 状态
                      alphabetNav.querySelectorAll('.account-dropdown-alphabet-nav-item').forEach(function (item) {
                        item.classList.remove('active');
                      });
                      navItem.classList.add('active');

                      // 独立处理滚动，不依赖任何全局下拉管理器
                      // 确保下拉菜单是打开的
                      var wasClosed = !isOpen;
                      if (wasClosed) {
                        toggleDropdown();
                      }

                      // 直接通过闭包中的 countryList 查找目标项
                      var targetItem = countryList.querySelector('[data-letter="' + letter + '"]');
                      if (targetItem) {
                        // 重新查找滚动容器，确保在正确的作用域内
                        var scrollContainer = countryList.parentElement;
                        if (scrollContainer && scrollContainer.classList.contains('account-dropdown-list-container')) {
                          // 如果下拉菜单刚打开，需要等待它完全展开
                          var delay = wasClosed ? 200 : 0;

                          setTimeout(function () {
                            // 计算目标项相对于滚动容器的位置
                            var scrollTop = targetItem.offsetTop;

                            // 使用 scrollTo 方法实现平滑滚动
                            if (scrollContainer.scrollTo) {
                              scrollContainer.scrollTo({
                                top: scrollTop,
                                behavior: 'smooth',
                              });
                            } else {
                              // 降级方案：直接设置 scrollTop（CSS scroll-behavior: smooth 会处理动画）
                              scrollContainer.scrollTop = scrollTop;
                            }
                          }, delay);
                        }
                      }
                    });

                    alphabetNav.appendChild(navItem);
                  });
                }

                // 生成选项
                sortedCountries.forEach(function (country) {
                  var li = document.createElement('li');
                  li.className = 'select-options-item account-dropdown-item';
                  li.setAttribute('data-value', country.code.toLowerCase());
                  var firstLetter = country.country.charAt(0).toUpperCase();
                  li.setAttribute('data-letter', firstLetter);
                  li.textContent = country.country;

                  // 添加点击事件处理
                  li.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCountrySelect(li);
                  });

                  countryList.appendChild(li);

                  // 保存到 allCountryItems 数组，用于搜索过滤
                  allCountryItems.push(li);
                });

                // 添加滚动监听，高亮当前可见的字母
                // listContainer 已在函数开头定义，直接使用
                if (listContainer) {
                  var lastActiveLetter = null;

                  var updateActiveLetter = function () {
                    var scrollTop = listContainer.scrollTop;
                    var items = countryList.querySelectorAll('.account-dropdown-item');
                    var activeLetter = null;

                    // 查找当前可见的第一个国家
                    for (var i = 0; i < items.length; i++) {
                      var item = items[i];
                      var itemTop = item.offsetTop - listContainer.scrollTop;
                      if (itemTop >= 0) {
                        activeLetter = item.getAttribute('data-letter');
                        break;
                      }
                    }

                    // 如果没有找到，使用最后一个可见的
                    if (!activeLetter && items.length > 0) {
                      for (var j = items.length - 1; j >= 0; j--) {
                        var item = items[j];
                        var itemTop = item.offsetTop - listContainer.scrollTop;
                        var itemHeight = item.offsetHeight;
                        if (itemTop + itemHeight > 0) {
                          activeLetter = item.getAttribute('data-letter');
                          break;
                        }
                      }
                    }

                    // 更新字母表导航的 active 状态
                    if (activeLetter && activeLetter !== lastActiveLetter && alphabetNav) {
                      alphabetNav.querySelectorAll('.account-dropdown-alphabet-nav-item').forEach(function (navItem) {
                        navItem.classList.remove('active');
                      });
                      var activeNavItem = alphabetNav.querySelector('[data-letter="' + activeLetter + '"]');
                      if (activeNavItem) {
                        activeNavItem.classList.add('active');
                      }
                      lastActiveLetter = activeLetter;
                    }
                  };

                  listContainer.addEventListener('scroll', updateActiveLetter);
                  // 初始化时也更新一次
                  setTimeout(updateActiveLetter, 100);
                }
              })
              .catch(function (error) {
                console.error('Failed to initialize country dropdown:', error);
              });
          }

          async uploadAvatar(file) {
            const formData = new FormData();
            formData.append('image', file);
            try {
              const res = await window.pq.http.post('/shopify/user/update', {
                data: formData,
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
              if (res.code === 200) {
                window.pqToast.showToast('success', window.pqI18n.request_successful);
                // 可选：更新本地存储或页面显示
                window.pq.setLocalStorage('pqUserInfo', { ...res.data });
                return res.data;
              } else if (res.code === 10102001) {
                throw new Error(window.pqI18n.error_message_10102001);
              } else if (res.code === 10102002) {
                throw new Error(window.pqI18n.error_message_10102002);
              } else if (res.code === 10102003) {
                throw new Error(window.pqI18n.error_message_10102003);
              } else if (res.code === 10102004) {
                throw new Error(window.pqI18n.error_message_10102004);
              } else if (res.code === 10102005) {
                throw new Error(window.pqI18n.error_message_10102005);
              } else {
                throw new Error(res.message || window.pqI18n.error_request_failed);
              }
            } catch (err) {
              throw new Error(err);
            }
          }
          // 初始化组件
          init() {
            var section = this.querySelector('[data-account-profile]');
            if (!section) return;

            // 返回按钮点击事件
            var backBtn = this.querySelector('.account-profile-back-btn');
            if (backBtn) {
              backBtn.addEventListener('click', function () {
                if (window.pq && window.pq.eventBus && typeof window.pq.eventBus.publish === 'function') {
                  window.pq.eventBus.publish('account:switchTab', 'overview');
                }
              });
            }

            var editBtn = section.querySelector('[data-account-profile-edit]');
            if (!editBtn) return;

            // 初始化国家下拉选项
            this.initCountryDropdown(section);
            var editableElements = section.querySelectorAll('.js-account-editable');
            var saveBtn = section.querySelector('[data-account-profile-save]');
            var cancelBtn = section.querySelector('[data-account-profile-cancel]');
            var dobInput = section.querySelector('#account-dob');
            var avatarTrigger = section.querySelector('[data-account-avatar-trigger]');
            var avatarTriggerContainer = this.querySelector('.account-profile-avatar');
            var avatarInput = null;

            // 头像选择（仅前端触发事件，具体上传由上层处理）
            if (avatarTrigger) {
              avatarInput = document.createElement('input');
              avatarInput.type = 'file';
              avatarInput.accept = 'image/*';
              avatarInput.style.display = 'none';
              avatarTrigger.appendChild(avatarInput);

              var self = this;
              avatarTrigger.addEventListener('click', function () {
                avatarInput.click();
              });

              avatarInput.addEventListener('change', async function () {
                var file = avatarInput.files && avatarInput.files[0];
                if (!file) return;

                // 本地预览
                var url = URL.createObjectURL(file);
                var img = avatarTrigger.querySelector('img');
                var placeholder = avatarTrigger.querySelector('span');
                // 上传头像后：移除首字母样式，恢复白底
                avatarTriggerContainer.classList.remove('is-initial');
                if (placeholder) {
                  placeholder.style.display = 'none';
                }
                if (!img) {
                  img = document.createElement('img');
                  avatarTrigger.insertBefore(img, avatarTrigger.firstChild);
                }
                img.src = url;

                // 上传头像到服务器
                try {
                  const formData = new FormData();
                  formData.append('image', file);

                  const res = await window.pq.http.post('/shopify/user/update', {
                    data: formData,
                    headers: {
                      'Content-Type': 'multipart/form-data',
                    },
                  });

                  if (res.code === 200) {
                    window.pqToast.showToast('success', window.pqI18n.request_successful);
                    // 更新本地存储
                    if (window.pq && typeof window.pq.setLocalStorage === 'function') {
                      window.pq.setLocalStorage('pqUserInfo', { ...res.data });
                      window.pq.eventBus.publish('account:updateAvatar', res.data);
                    }
                  } else if (res.code === 10102001) {
                    throw new Error(window.pqI18n.error_message_10102001);
                  } else if (res.code === 10102002) {
                    throw new Error(window.pqI18n.error_message_10102002);
                  } else if (res.code === 10102003) {
                    throw new Error(window.pqI18n.error_message_10102003);
                  } else if (res.code === 10102004) {
                    throw new Error(window.pqI18n.error_message_10102004);
                  } else if (res.code === 10102005) {
                    throw new Error(window.pqI18n.error_message_10102005);
                  } else {
                    throw new Error(res.message || window.pqI18n.error_request_failed);
                  }
                } catch (err) {
                  console.error('上传头像失败:', err);
                  window.pqToast.showToast('error', err.message || window.pqI18n.error_request_failed);
                  // 上传失败时恢复原始头像
                  if (img && img.src && img.src.startsWith('blob:')) {
                    URL.revokeObjectURL(img.src);
                    img.remove();
                    if (placeholder) {
                      placeholder.style.display = '';
                    }
                  }
                }

                // 向外派发事件，通知其他组件（可选）
                var changeEvent = new CustomEvent('account-profile:avatar-change', {
                  detail: {
                    file: file,
                    section: section,
                  },
                });
                document.dispatchEvent(changeEvent);
              });
            }

            // 从 localStorage 读取用户信息
            var getUserInfoFromStorage = function () {
              try {
                var stored = localStorage.getItem('pqUserInfo');
                if (stored) {
                  return JSON.parse(stored);
                }
              } catch (e) {
                console.error('Failed to parse pqUserInfo from localStorage:', e);
              }
              return null;
            };

            // 获取表单元素
            var firstNameEl = section.querySelector('#account-first-name');
            var lastNameEl = section.querySelector('#account-last-name');
            var dobEl = section.querySelector('#account-dob');
            var phoneEl = section.querySelector('#account-phone');
            var genderTrigger = section.querySelector('[data-dropdown-trigger="account-gender"]');
            var countryTrigger = section.querySelector('[data-country-trigger]');
            var greetingEmailEl = section.querySelector('.account-profile-greeting-email');

            // 从 localStorage 读取数据并填充表单（默认使用 localStorage 数据）
            var userInfo = getUserInfoFromStorage();
            // 填充 First Name（使用 localStorage 数据）
            if (firstNameEl) {
              firstNameEl.value = userInfo && userInfo.firstName ? userInfo.firstName : '';
            }
            // 填充 Last Name（使用 localStorage 数据）
            if (lastNameEl) {
              lastNameEl.value = userInfo && userInfo.lastName ? userInfo.lastName : '';
            }
            // 填充 Date of Birth（使用 localStorage 数据）
            if (dobEl) {
              dobEl.value = userInfo && userInfo.birthday ? userInfo.birthday : '';
            }
            // 填充 Phone Number（使用 localStorage 数据）
            if (phoneEl) {
              phoneEl.value = userInfo && userInfo.phone ? userInfo.phone : '';
            }
            if (userInfo) {
              // 填充 Gender（如果存在且不为 null）
              if (genderTrigger && userInfo.gender) {
                // 将数字格式转换为字符串，支持 1、2、3 或 "male"、"female"、"other"
                var genderNum = parseInt(userInfo.gender, 10);
                var genderValue = '';
                var genderLabel = '';

                if (!isNaN(genderNum)) {
                  // 数字格式：1=male, 2=female, 3=other
                  genderValue = String(genderNum);
                  genderLabel =
                    genderNum === 1
                      ? window.pqI18n.gender_male
                      : genderNum === 2
                      ? window.pqI18n.gender_female
                      : window.pqI18n.gender_prefer_not_to_say;
                } else {
                  // 字符串格式（兼容旧数据）
                  var genderStr = String(userInfo.gender).toLowerCase();
                  if (genderStr === 'male') {
                    genderValue = '1';
                    genderLabel = window.pqI18n.gender_male;
                  } else if (genderStr === 'female') {
                    genderValue = '2';
                    genderLabel = window.pqI18n.gender_female;
                  } else if (genderStr === 'other') {
                    genderValue = '3';
                    genderLabel = window.pqI18n.gender_prefer_not_to_say;
                  }
                }

                if (genderValue) {
                  genderTrigger.dataset.value = genderValue;
                  var gLabelSpan = genderTrigger.querySelector('.account-select-label');
                  if (gLabelSpan) {
                    gLabelSpan.textContent = genderLabel;
                  }
                }
              }
              // 填充 Country（使用 localStorage 数据，从 country.json 匹配）
              if (countryTrigger && userInfo.country) {
                var countryCode = String(userInfo.country).toLowerCase();
                countryTrigger.dataset.value = countryCode;
                var countryLabel = String(userInfo.country).toUpperCase();
                var cLabelSpan = countryTrigger.querySelector('.account-select-label');
                var countryField = countryTrigger.closest('.floating-field');
                if (cLabelSpan) {
                  // 尝试从 country.json 数据中查找匹配的国家名称
                  var self = this;
                  var setCountryLabel = function () {
                    if (self.countryData) {
                      var matchedCountry = self.countryData.find(function (c) {
                        return c.code.toLowerCase() === countryCode;
                      });
                      if (matchedCountry) {
                        countryLabel = matchedCountry.country;
                      }
                    } else {
                      // 如果数据还未加载，尝试从下拉选项中查找
                      var countryDropdown = section.querySelector('[data-dropdown-content="account-country"]');
                      if (countryDropdown) {
                        var countryItem = countryDropdown.querySelector('[data-value="' + countryCode + '"]');
                        if (countryItem) {
                          countryLabel = countryItem.textContent.trim();
                        }
                      }
                    }
                    // input 元素使用 value，span 元素使用 textContent
                    if (cLabelSpan.tagName === 'INPUT') {
                      cLabelSpan.value = countryLabel;
                    } else {
                      cLabelSpan.textContent = countryLabel;
                    }
                    // 保存选中的国家名称到 dataset
                    if (countryTrigger) {
                      countryTrigger.dataset.selectedCountryName = countryLabel;
                    }
                  };

                  // 如果数据已加载，直接设置；否则等待加载完成
                  if (this.countryData) {
                    setCountryLabel();
                  } else {
                    this.loadCountryData().then(function () {
                      setCountryLabel();
                    });
                  }
                }
              }
              // 更新邮箱显示（使用 localStorage 数据）
              if (greetingEmailEl && userInfo.email) {
                greetingEmailEl.textContent = userInfo.email;
              }
              // 更新头像（使用 localStorage 的 avatarLink）
              if (avatarTrigger) {
                var avatarContainer = avatarTrigger.closest('.account-profile-avatar');
                if (userInfo.avatarLink) {
                  // 有头像链接，显示图片（白色背景）
                  if (avatarContainer) {
                    avatarContainer.classList.remove('is-initial');
                  }
                  var img = avatarTrigger.querySelector('img');
                  var placeholder = avatarTrigger.querySelector('span');
                  if (placeholder) {
                    placeholder.style.display = 'none';
                  }
                  if (!img) {
                    img = document.createElement('img');
                    avatarTrigger.insertBefore(img, avatarTrigger.firstChild);
                  }
                  img.src = userInfo.avatarLink;
                  img.alt = 'avatar';
                  img.style.display = 'block';
                } else {
                  // 没有头像链接，显示邮箱首字母（橙色背景）
                  if (avatarContainer) {
                    avatarContainer.classList.add('is-initial');
                  }
                  var placeholder = avatarTrigger.querySelector('span');
                  if (placeholder) {
                    // 优先使用邮箱首字母，如果没有邮箱则使用 firstName 首字母
                    var initial = '';
                    if (userInfo.email && userInfo.email.length > 0) {
                      initial = userInfo.email.charAt(0);
                    }
                    placeholder.textContent = initial.toUpperCase();
                    placeholder.style.display = 'flex';
                  }
                  var img = avatarTrigger.querySelector('img');
                  if (img) {
                    img.style.display = 'none';
                  }
                }
              }
            }

            // 日期选择器：参考 main-customers-account.js 中的 flatpickr 配置 + 国际化星期
            // 使用 onFlatpickrReady 确保 flatpickr 加载完成后再初始化
            if (dobInput && window.onFlatpickrReady) {
              window.onFlatpickrReady(function () {
                try {
                  // 从 window.pqI18n.weekdays 中读取本地化星期名（如果存在）
                  var getWeekdayName = function (dayKey, defaultShort, defaultLong) {
                    if (window.pqI18n && window.pqI18n.weekdays && window.pqI18n.weekdays[dayKey]) {
                      var name = window.pqI18n.weekdays[dayKey];
                      var short = name.length > 3 ? name.substring(0, 3) : name;
                      return { short: short, long: name };
                    }
                    return { short: defaultShort, long: defaultLong };
                  };

                  var monday = getWeekdayName('monday', 'Mon', 'Monday');
                  var tuesday = getWeekdayName('tuesday', 'Tue', 'Tuesday');
                  var wednesday = getWeekdayName('wednesday', 'Wed', 'Wednesday');
                  var thursday = getWeekdayName('thursday', 'Thu', 'Thursday');
                  var friday = getWeekdayName('friday', 'Fri', 'Friday');
                  var saturday = getWeekdayName('saturday', 'Sat', 'Saturday');
                  var sunday = getWeekdayName('sunday', 'Sun', 'Sunday');

                  var customLocale = {
                    weekdays: {
                      shorthand: [
                        sunday.short,
                        monday.short,
                        tuesday.short,
                        wednesday.short,
                        thursday.short,
                        friday.short,
                        saturday.short,
                      ],
                      longhand: [
                        sunday.long,
                        monday.long,
                        tuesday.long,
                        wednesday.long,
                        thursday.long,
                        friday.long,
                        saturday.long,
                      ],
                    },
                  };

                  if (typeof flatpickr.localize === 'function') {
                    flatpickr.localize(customLocale);
                  }

                  flatpickr(dobInput, {
                    locale: customLocale,
                    dateFormat: 'Y-m-d',
                    disableMobile: true,
                    showMonths: 1,
                    showOutsideDays: true,
                  });
                } catch (e) {
                  console.error('flatpickr init error in account-profile:', e);
                }
              });
            }

            // 必填项实时校验：有值时移除 field-error
            var floatingFields = section.querySelectorAll('.floating-field');
            floatingFields.forEach(function (field) {
              var input = field.querySelector('input');
              var trigger = field.querySelector('.account-select-trigger');
              if (!input && !trigger) return;

              var getDisplayText = function () {
                if (input) return (input.value || '').trim();
                var labelSpan = trigger && trigger.querySelector('.account-select-label');
                return labelSpan ? labelSpan.textContent.trim() : '';
              };
              var baseLabel = trigger && trigger.dataset && trigger.dataset.label ? trigger.dataset.label.trim() : '';
              var isRequiredField = field.hasAttribute('data-required');

              var updateErrorState = function () {
                var text = getDisplayText();
                var hasValue = input
                  ? text.length > 0
                  : (text && text !== baseLabel) || (trigger.dataset && trigger.dataset.value);
                if (hasValue) {
                  field.classList.remove('field-error');
                } else if (isRequiredField && section.getAttribute('data-editing') === 'true') {
                  field.classList.add('field-error');
                } else {
                  field.classList.remove('field-error');
                }
              };

              if (input) {
                input.addEventListener('input', updateErrorState);
                input.addEventListener('blur', updateErrorState);
              }
              if (trigger) {
                trigger.addEventListener('blur', updateErrorState);
              }
            });

            function getFieldValue(field) {
              var input = field.querySelector('input');
              var trigger = field.querySelector('.account-select-trigger');
              if (input) return (input.value || '').trim();
              if (trigger) {
                var labelSpan = trigger.querySelector('.account-select-label');
                var text = labelSpan ? labelSpan.textContent.trim() : '';
                var baseLabel = trigger.dataset && trigger.dataset.label ? trigger.dataset.label.trim() : '';
                if (text && text !== baseLabel) return text;
                if (trigger.dataset && trigger.dataset.value) return trigger.dataset.value;
              }
              return '';
            }

            function validateFields() {
              var isValid = true;
              var requiredFields = section.querySelectorAll('.floating-field[data-required="true"]');
              requiredFields.forEach(function (field) {
                var hasValue = getFieldValue(field).length > 0;
                var errorEl = field.querySelector('.account-profile-error');
                if (!hasValue) {
                  isValid = false;
                  field.classList.add('field-error');
                  if (errorEl) {
                    errorEl.textContent = (window.pqI18n && window.pqI18n.required) || 'Required';
                  }
                } else {
                  field.classList.remove('field-error');
                }
              });
              return isValid;
            }

            function setEditing(isEditing) {
              section.setAttribute('data-editing', isEditing ? 'true' : 'false');
              editableElements.forEach(function (el) {
                if ('disabled' in el) {
                  // el.disabled = !isEditing;
                }
              });
              // 控制国家搜索 input 的 readonly 状态
              var countrySearchInput = section.querySelector('.account-country-search-input');
              if (countrySearchInput) {
                if (isEditing) {
                  countrySearchInput.removeAttribute('readonly');
                } else {
                  countrySearchInput.setAttribute('readonly', 'readonly');
                }
              }
            }

            // 初始化为不可编辑
            setEditing(false);

            editBtn.addEventListener('click', function (e) {
              e.preventDefault();
              var isEditing = section.getAttribute('data-editing') === 'true';
              setEditing(!isEditing);
            });

            // 导航栏中的编辑图标点击事件
            var navEditIcon = this.querySelector('.account-profile-nav-right-item');
            if (navEditIcon) {
              navEditIcon.addEventListener('click', function (e) {
                e.preventDefault();
                // 触发与原有编辑按钮相同的逻辑
                var isEditing = section.getAttribute('data-editing') === 'true';
                setEditing(!isEditing);
                navEditIcon.classList.add('hidden');
              });
            }

            // 通过事件总线控制进入编辑模式 / 监听标签切换 / 外部关闭编辑
            if (window.pq && window.pq.eventBus && typeof window.pq.eventBus.subscribe === 'function') {
              // 外部触发进入编辑模式
              window.pq.eventBus.subscribe('account:profile:edit', function () {
                setEditing(true);
                var navEditIcon = document.querySelector('.account-profile-nav-right-item');
                if (navEditIcon) {
                  navEditIcon.classList.add('hidden');
                }
              });

              // 公用的“关闭编辑并恢复初始状态”逻辑
              var closeEditAndReset = function () {
                // 关闭编辑状态
                setEditing(false);

                // 清除 profile 内所有校验错误（恢复初始状态）
                var fields = section.querySelectorAll('.floating-field');
                fields.forEach(function (field) {
                  field.classList.remove('field-error');
                });

                // 同时清理全局的 input_text_container 错误状态（PC / Mobile 统一处理）
                var errorInputs = document.querySelectorAll('.input_text_container[data-error="true"]');
                errorInputs.forEach(function (el) {
                  el.setAttribute('data-error', 'false');
                  var errorEl = el.nextElementSibling;
                  if (errorEl && errorEl.classList.contains('error-message')) {
                    errorEl.classList.add('hidden');
                  }
                });
              };

              // 当切换到其他 tab（例如 /account?type=xxx）时，重置为初始状态
              window.pq.eventBus.subscribe('account:switchTab', function (tab) {
                // 当前 tab 切走 profile 时才处理
                if (tab !== 'profile') {
                  closeEditAndReset();
                }
              });

              // 外部任意地方可调用：window.pq.eventBus.publish('account:closeEdit', true)
              window.pq.eventBus.subscribe('account:closeEdit', function (shouldClose) {
                if (shouldClose === false) return;
                closeEditAndReset();
              });
            }

            // 从 localStorage 恢复数据的函数
            var restoreFromLocalStorage = function (componentInstance) {
              var userInfo = getUserInfoFromStorage();

              // 恢复 input 字段
              if (firstNameEl) {
                firstNameEl.value = userInfo && userInfo.firstName ? userInfo.firstName : '';
              }
              if (lastNameEl) {
                lastNameEl.value = userInfo && userInfo.lastName ? userInfo.lastName : '';
              }
              if (dobEl) {
                dobEl.value = userInfo && userInfo.birthday ? userInfo.birthday : '';
              }
              if (phoneEl) {
                phoneEl.value = userInfo && userInfo.phone ? userInfo.phone : '';
              }

              // 恢复 Gender
              if (genderTrigger) {
                if (userInfo && userInfo.gender) {
                  // 将数字格式转换为字符串，支持 1、2、3 或 "male"、"female"、"other"
                  var genderNum = parseInt(userInfo.gender, 10);
                  var genderValue = '';
                  var genderLabel = '';

                  if (!isNaN(genderNum)) {
                    // 数字格式：1=male, 2=female, 3=other
                    genderValue = String(genderNum);
                    genderLabel =
                      genderNum === 1
                        ? window.pqI18n.gender_male
                        : genderNum === 2
                        ? window.pqI18n.gender_female
                        : window.pqI18n.gender_prefer_not_to_say;
                  } else {
                    // 字符串格式（兼容旧数据）
                    var genderStr = String(userInfo.gender).toLowerCase();
                    if (genderStr === 'male') {
                      genderValue = '1';
                      genderLabel = window.pqI18n.gender_male;
                    } else if (genderStr === 'female') {
                      genderValue = '2';
                      genderLabel = window.pqI18n.gender_female;
                    } else if (genderStr === 'other') {
                      genderValue = '3';
                      genderLabel = window.pqI18n.gender_prefer_not_to_say;
                    }
                  }

                  if (genderValue) {
                    genderTrigger.dataset.value = genderValue;
                    var gLabel = genderTrigger.querySelector('.account-select-label');
                    if (gLabel) gLabel.textContent = genderLabel;
                  } else {
                    genderTrigger.dataset.value = '';
                    var gLabel = genderTrigger.querySelector('.account-select-label');
                    if (gLabel) gLabel.textContent = genderTrigger.getAttribute('data-label') || '';
                  }
                } else {
                  genderTrigger.dataset.value = '';
                  var gLabel = genderTrigger.querySelector('.account-select-label');
                  if (gLabel) gLabel.textContent = genderTrigger.getAttribute('data-label') || '';
                }
              }

              // 恢复 Country
              if (countryTrigger) {
                if (userInfo && userInfo.country) {
                  var countryCode = String(userInfo.country).toLowerCase();
                  countryTrigger.dataset.value = countryCode;
                  var setCountryLabel = function () {
                    var countryLabel = String(userInfo.country).toUpperCase();
                    if (componentInstance.countryData) {
                      var matchedCountry = componentInstance.countryData.find(function (c) {
                        return c.code.toLowerCase() === countryCode;
                      });
                      if (matchedCountry) {
                        countryLabel = matchedCountry.country;
                      }
                    }
                    var cLabel = countryTrigger.querySelector('.account-select-label');
                    if (cLabel) {
                      // input 元素使用 value，span 元素使用 textContent
                      if (cLabel.tagName === 'INPUT') {
                        cLabel.value = countryLabel;
                      } else {
                        cLabel.textContent = countryLabel;
                      }
                    }
                    // 保存选中的国家名称到 dataset
                    countryTrigger.dataset.selectedCountryName = countryLabel;
                  };
                  if (componentInstance.countryData) {
                    setCountryLabel();
                  } else {
                    componentInstance.loadCountryData().then(function () {
                      setCountryLabel();
                    });
                  }
                } else {
                  countryTrigger.dataset.value = '';
                  countryTrigger.dataset.selectedCountryName = ''; // 清空保存的国家名称
                  var cLabel = countryTrigger.querySelector('.account-select-label');
                  if (cLabel) {
                    // input 元素使用 value，span 元素使用 textContent
                    if (cLabel.tagName === 'INPUT') {
                      cLabel.value = '';
                    } else {
                      cLabel.textContent = '';
                    }
                  }
                }
              }
            };

            if (cancelBtn) {
              var self = this;
              cancelBtn.addEventListener('click', function (e) {
                e.preventDefault();

                // 从 localStorage 恢复数据
                restoreFromLocalStorage(self);
                var navEditIcon = self.querySelector('.account-profile-nav-right-item');
                if (navEditIcon) {
                  navEditIcon.classList.remove('hidden');
                }
                // 重置错误状态
                var fields = section.querySelectorAll('.floating-field');
                fields.forEach(function (field) {
                  field.classList.remove('field-error');
                });

                setEditing(false);
              });
            }

            // 监听下拉选项点击，更新显示文本与存值
            // 注意：国家下拉菜单已独立实现，不通过此事件处理
            var self = this;
            document.addEventListener('global-select:option-click', function (evt) {
              var detail = evt.detail || {};
              var trigger = detail.trigger;
              if (!trigger) return;
              var componentType = trigger.getAttribute('data-component');
              if (componentType !== 'account-profile') return;

              // 排除国家下拉菜单（已独立实现）
              if (trigger.hasAttribute('data-country-trigger')) return;

              var text =
                detail.data && detail.data.valueText
                  ? detail.data.valueText
                  : detail.item
                  ? detail.item.textContent.trim()
                  : '';
              var value =
                detail.data && detail.data.value
                  ? detail.data.value
                  : detail.item
                  ? detail.item.getAttribute('data-value')
                  : '';

              var labelSpan = trigger.querySelector('.account-select-label');
              if (labelSpan) {
                labelSpan.textContent = text;
              }
              if (value !== undefined) {
                trigger.dataset.value = value;
              }

              var field = trigger.closest('.floating-field');
              if (field) {
                field.classList.remove('field-error');
              }
            });

            if (saveBtn) {
              var self = this;
              saveBtn.addEventListener('click', async function (e) {
                e.preventDefault();

                // 校验必填项
                if (!validateFields()) {
                  return;
                }

                var formData = new FormData();
                var firstNameEl = section.querySelector('#account-first-name');
                var lastNameEl = section.querySelector('#account-last-name');
                var dobEl = section.querySelector('#account-dob');
                var phoneEl = section.querySelector('#account-phone');
                var genderTrigger = section.querySelector('[data-dropdown-trigger="account-gender"]');
                var countryTrigger = section.querySelector('[data-country-trigger]');

                if (firstNameEl) formData.append('firstName', (firstNameEl.value || '').trim());
                if (lastNameEl) formData.append('lastName', (lastNameEl.value || '').trim());
                if (dobEl) formData.append('birthday', (dobEl.value || '').trim());
                if (phoneEl) formData.append('phone', (phoneEl.value || '').trim());
                if (genderTrigger && genderTrigger.dataset.value) {
                  // gender 值已经是数字格式（1、2、3），直接传递
                  formData.append('gender', genderTrigger.dataset.value);
                }
                window.pq.eventBus.publish('account:initTask');

                if (window.innerWidth <= 1200) {
                  const navEditIcon = document.querySelector('.account-profile-nav-right-item');

                  if (navEditIcon) {
                    navEditIcon.classList.remove('hidden');
                  }
                }
                if (countryTrigger) formData.append('country', countryTrigger.dataset.value || '');

                try {
                  // 添加 loading 状态
                  saveBtn.setAttribute('data-show-loading', 'true');
                  section.classList.add('is-loading');

                  var res = await window.pq.http.post('/shopify/user/update', { data: formData });
                  if (res && res.code === 200) {
                    if (window.pq && typeof window.pq.setLocalStorage === 'function') {
                      window.pq.setLocalStorage('pqUserInfo', res.data);
                    }
                    if (window.pqToast && typeof window.pqToast.showToast === 'function') {
                      window.pqToast.showToast(
                        'success',
                        (window.pqI18n && window.pqI18n.save_successfully) || 'Saved successfully'
                      );
                    }
                    window.pq.eventBus.publish('account:updateUserInfo');
                    window.pq.eventBus.publish('account:initTask');
                    window.pq.eventBus.publish('account:getMemberPoints');

                    setEditing(false);
                  } else {
                    throw new Error(res.message);
                  }
                } catch (err) {
                  if (window.pqToast && typeof window.pqToast.showToast === 'function') {
                    window.pqToast.showToast('error', (window.pqI18n && window.pqI18n.save_failed) || 'Save failed');
                  }
                } finally {
                  // 移除 loading 状态
                  saveBtn.removeAttribute('data-show-loading');
                  section.classList.remove('is-loading');
                }
              });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-shipping-address"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('account-shipping-address')) {
      customElements.define(
        'account-shipping-address',
        class AccountShippingAddress extends HTMLElement {
          submitBtn = null;
          form = null;
          currentPopupId = null;
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.changeCountry();
            var backBtn = this.querySelector('.account-address-back-btn');
            if (backBtn) {
              backBtn.addEventListener('click', function () {
                if (window.pq && window.pq.eventBus && typeof window.pq.eventBus.publish === 'function') {
                  window.pq.eventBus.publish('account:switchTab', 'overview');
                }
              });
            }
          }
          disconnectedCallback() {
            // 清理事件监听器
          }
          init() {
            const _this = this;
            const addresses = _this.querySelectorAll('[data-address]');
            addresses.forEach((el) => {
              el.addEventListener('click', function () {
                _this.changeCountryOption();
                _this.editAddress(this.dataset.address);
              });
            });
            const addressCancel = _this.querySelectorAll('.address_cancel');
            addressCancel.forEach((el) => {
              el.addEventListener('click', function () {
                _this.cancelAddress();
              });
            });
            const addNewAddress = _this.querySelectorAll('.account-shipping-add-btn');
            addNewAddress.forEach((el) => {
              el.addEventListener('click', function () {
                _this.changeCountryOption();
                _this.editAddress();
              });
            });
            const accountMobileAddAddressContgainer = _this.querySelectorAll('.account-mobile-add-address-contgainer');
            accountMobileAddAddressContgainer.forEach((el) => {
              // iOS兼容性：同时添加touch和click事件
              const handleAddAddress = function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this.changeCountryOption();
                _this.editAddress();
              };

              el.addEventListener('click', handleAddAddress);
              el.addEventListener('touchend', handleAddAddress);

              // 防止iOS上的双击缩放
              el.addEventListener('touchstart', function (e) {
                e.preventDefault();
              });
            });
            const addressDelete = _this.querySelectorAll('[data-delete_id]');
            addressDelete.forEach((el) => {
              el.addEventListener('click', function () {
                window.pq.scrollDisable();
                _this.deleteAddress(this.dataset.delete_id);
              });
            });

            const cancelDeletePopup = _this.querySelectorAll('.cancen_delete_popup');
            cancelDeletePopup.forEach((el) => {
              el.addEventListener('click', function () {
                _this.closeDeletePopup();
              });
            });

            // 设置默认地址的 checkbox 事件
            const setDefaultCheckboxes = _this.querySelectorAll('.set-default-address-checkbox');
            setDefaultCheckboxes.forEach((checkbox) => {
              checkbox.addEventListener('change', function () {
                if (this.checked) {
                  const addressId = this.getAttribute('data-address-id');
                  _this.setDefaultAddress(addressId);
                }
              });
            });
            
            // 初始化时更新移动端新增按钮的显示状态
            _this.updateMobileAddButton();
            
            // 监听窗口大小变化，动态更新移动端新增按钮显示状态
            _this.resizeHandler = function() {
              _this.updateMobileAddButton();
            };
            window.addEventListener('resize', _this.resizeHandler);
          }

          changeCountry() {
            const _this = this;
            const countrySelectors = _this.querySelectorAll('.country-selector');
            if (countrySelectors.length > 0) {
              countrySelectors.forEach((countrySelect) => {
                countrySelect.addEventListener('change', function () {
                  const dataCountry = this.value;
                  const options = this.querySelectorAll('option');
                  let provinces = null;
                  options.forEach((option) => {
                    if (option.value === dataCountry) {
                      provinces = JSON.parse(option.getAttribute('data-provinces'));
                    }
                  });
                  const addressForm = this.closest('.address-popup-container');
                  const provinceSelectors = addressForm.querySelectorAll('.province-selector');

                  if (provinces && provinces.length > 0) {
                    const optionsHtml = provinces
                      .map(([code, name]) => `<option value="${code}">${name}</option>`)
                      .join('');

                    provinceSelectors.forEach((provinceSelector) => {
                      if (provinceSelector && provinceSelector.innerHTML !== undefined) {
                        provinceSelector.innerHTML = optionsHtml;
                        if (provinceSelector.options && provinceSelector.options.length > 0) {
                          provinceSelector.options[0].selected = true;
                        }
                        provinceSelector.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    });
                  } else {
                    provinceSelectors.forEach((provinceSelector) => {
                      provinceSelector.innerHTML = '';
                    });
                  }
                });
              });
            }
          }

          changeCountryOption() {
            const _this = this;
            const addressIdContainers = document.querySelectorAll('[data-address_id]');

            if (addressIdContainers.length > 0) {
              addressIdContainers.forEach((container) => {
                const countrySelectors = container.querySelectorAll('.country-selector');

                let dataCountry = countrySelectors[0]?.getAttribute('data-country');
                const options = countrySelectors[0]?.querySelectorAll('option');
                // 根据data-country获取option 为 dataCountry 的 option
                if (options) {
                  options.forEach((option) => {
                    if (option && option.value === dataCountry) {
                      option.selected = true;
                      option.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    if (option) {
                      option.defaultSelected = option.value === dataCountry;
                      if (option.value === '---') {
                        option.disabled = true;
                      }
                    }
                  });
                }
                let provinces = null;
                if (options) {
                  options.forEach((option) => {
                    if (option.value === dataCountry) {
                      provinces = JSON.parse(option.getAttribute('data-provinces'));
                    }
                  });
                }
                const provinceSelectors = container.querySelectorAll('.province-selector');
                if (provinces) {
                  const optionsHtml = provinces
                    .map(([code, name]) => `<option value="${code}">${name}</option>`)
                    .join('');

                  provinceSelectors.forEach((provinceSelector) => {
                    provinceSelector.innerHTML = optionsHtml;
                    const provinceSelectorValue = provinceSelector.getAttribute('data-country_prov');
                    if (provinceSelectorValue) {
                      setTimeout(() => {
                        const targetOption = provinceSelector.querySelector(`option[value="${provinceSelectorValue}"]`);
                        if (targetOption) targetOption.selected = true;
                        provinceSelector.querySelectorAll('option').forEach((opt) => {
                          opt.defaultSelected = opt.value === provinceSelectorValue;
                        });
                        provinceSelector.dispatchEvent(new Event('change', { bubbles: true }));
                      }, 100);
                    } else {
                      if (provinceSelector && provinceSelector.options && provinceSelector.options.length > 0) {
                        provinceSelector.options[0].selected = true;
                      }
                      if (provinceSelector) {
                        provinceSelector.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    }
                  });
                } else {
                  provinceSelectors.forEach((provinceSelector) => {
                    provinceSelector.innerHTML = '';
                  });
                }
              });
            }
          }

          deleteAddress(address_id) {
            const _this = this;
            const addressDelete = document.querySelectorAll('.addressDelete-popup');
            addressDelete.forEach((el) => {
              el.style.zIndex = '-99';
              el.style.opacity = '0';
            });
            const currentDeletelessPopup = document.querySelector(`[data-delete="${address_id}"]`);
            if (!currentDeletelessPopup) {
              console.error('找不到删除弹窗元素:', address_id);
              return;
            }
            currentDeletelessPopup.style.zIndex = '9999';
            currentDeletelessPopup.style.opacity = '1';
            
            // 自动滚动到页面顶部
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });

            // 添加点击 overlay 背景关闭弹窗的功能
            const overlayClickHandler = function (e) {
              if (e.target === currentDeletelessPopup) {
                _this.closeDeletePopup();
                currentDeletelessPopup.removeEventListener('click', overlayClickHandler);
              }
            };
            currentDeletelessPopup.addEventListener('click', overlayClickHandler);

            // 获取currentDeletelessPopup下的submit按钮
            const submitBtn = currentDeletelessPopup.querySelector('button[type="submit"]');
            submitBtn.addEventListener('click', async function (e) {
              e.preventDefault();
              const rotateIcon = submitBtn.querySelector('.rotate_icon');
              const loadingText = submitBtn.querySelector('.loading-button-text');
              if (rotateIcon) {
                rotateIcon.classList.remove('hidden');
                rotateIcon.classList.add('flex');
              }
              if (loadingText) {
                loadingText.classList.add('hidden');
                loadingText.classList.remove('flex');
              }
              await _this.deleteAddressConfirm(address_id);
              if (rotateIcon) {
                rotateIcon.classList.remove('flex');
                rotateIcon.classList.add('hidden');
              }
              if (loadingText) {
                loadingText.classList.add('flex');
                loadingText.classList.remove('hidden');
              }
            });
          }

          closeDeletePopup() {
            const addressDelete = document.querySelectorAll('.addressDelete-popup');
            addressDelete.forEach((el) => {
              el.style.zIndex = '-99';
              el.style.opacity = '0';
            });
            
            // 关闭弹窗时立即恢复滚动
            if (window.pq && typeof window.pq.enableScroll === 'function') {
              window.pq.enableScroll();
            }
          }

          updateMobileAddButton() {
            // 检查当前地址数量
            const addressCards = this.querySelectorAll('.address-card');
            const mobileAddButton = this.querySelector('.account-mobile-add-address-contgainer');
            
            if (mobileAddButton) {
              // 1024px及以上的桌面端，始终隐藏移动端新增按钮
              if (window.innerWidth >= 1024) {
                mobileAddButton.style.display = 'none';
              } else {
                // 1024px以下的移动端，根据地址数量决定显示/隐藏
                if (addressCards.length > 0) {
                  // 有地址时显示移动端新增按钮
                  mobileAddButton.style.display = 'flex';
                } else {
                  // 没有地址时隐藏移动端新增按钮
                  mobileAddButton.style.display = 'none';
                }
              }
            }
          }

          updateExternalPopups(newHtml) {
            // 查找新HTML中的account-shipping-address组件
            const newAccountShippingAddress = newHtml.querySelector('account-shipping-address');
            if (!newAccountShippingAddress) return;
            
            // 使用当前组件实例
            const currentAccountShippingAddress = this;
            if (!currentAccountShippingAddress) return;
            
            // 更新外部的地址编辑弹窗
            const newAddressPopups = newAccountShippingAddress.querySelectorAll('.address-popup');
            const currentAddressPopups = document.querySelectorAll('.address-popup');
            
            // 移除旧的弹窗
            currentAddressPopups.forEach(popup => {
              if (popup.parentNode) {
                popup.parentNode.removeChild(popup);
              }
            });
            
            // 添加新的弹窗到当前组件
            if (newAddressPopups.length > 0) {
              newAddressPopups.forEach(popup => {
                this.appendChild(popup.cloneNode(true));
              });
            }
            
            // 更新外部的删除弹窗
            const newDeletePopups = newAccountShippingAddress.querySelectorAll('.addressDelete-popup');
            const currentDeletePopups = document.querySelectorAll('.addressDelete-popup');
            
            // 移除旧的删除弹窗
            currentDeletePopups.forEach(popup => {
              if (popup.parentNode) {
                popup.parentNode.removeChild(popup);
              }
            });
            
            // 添加新的删除弹窗到当前组件
            if (newDeletePopups.length > 0) {
              newDeletePopups.forEach(popup => {
                this.appendChild(popup.cloneNode(true));
              });
            }
          }

          setDefaultAddress(addressId) {
            const _this = this;

            // 显示 loading 状态
            const layout = _this.querySelector('.account-shipping-layout');
            if (layout) {
              layout.classList.add('is-loading');
              layout.style.overflow = 'hidden';
            }

            // 创建表单数据
            const formData = new FormData();
            formData.append('_method', 'put');
            formData.append('address[default]', 'true');

            // 发送请求设置默认地址
            fetch(`/account/addresses/${addressId}`, {
              method: 'POST',
              body: formData,
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
            })
              .then(async (response) => {
                if (response.ok) {
                  // 成功后刷新页面内容
                  try {
                    const orderUrl = window.location.href;
                    const res = await fetch(`${orderUrl}`, { credentials: 'same-origin' });
                    if (!res.ok) throw new Error('Failed to load address list');

                    const responseText = await res.text();
                    const html = new DOMParser().parseFromString(responseText, 'text/html');

                    // 当前组件内的布局容器（包含列表 + 弹窗）
                    const currentLayout = _this.querySelector('.account-shipping-layout');
                    // 新 HTML 中对应的布局容器
                    const newLayout = html.querySelector('.account-shipping-layout');

                    if (currentLayout && newLayout) {
                      // 用新内容替换旧内容（列表 + 所有编辑/删除弹窗）
                      currentLayout.innerHTML = newLayout.innerHTML;
                      // 更新外部弹窗元素
                      _this.updateExternalPopups(html);
                      // 更新移动端新增按钮的显示状态
                      _this.updateMobileAddButton();
                      // 重新绑定事件（编辑 / 删除 / 新增 等）
                      _this.init();
                      _this.changeCountry();
                    }
                  } catch (err) {
                    console.error('刷新地址列表失败:', err);
                    if (window.pq && typeof window.pq.showToast === 'function') {
                      window.pq.showToast('error', window.i18n?.request_failed || 'Request failed');
                    }
                  }
                } else {
                  console.error('设置默认地址失败:', response.statusText);
                  // 取消选中状态
                  const checkbox = _this.querySelector(`[data-address-id="${addressId}"]`);
                  if (checkbox) {
                    checkbox.checked = false;
                  }
                }

                // 移除 loading 状态
                if (layout) {
                  layout.classList.remove('is-loading');
                  layout.style.overflow = '';
                }
              })
              .catch((error) => {
                console.error('设置默认地址失败:', error);
                // 取消选中状态
                const checkbox = _this.querySelector(`[data-address-id="${addressId}"]`);
                if (checkbox) {
                  checkbox.checked = false;
                }

                // 移除 loading 状态
                if (layout) {
                  layout.classList.remove('is-loading');
                  layout.style.overflow = '';
                }
              });
          }

          deleteAddressConfirm(address_id) {
            const _this = this;
            // 获取address_id弹窗下的form
            return new Promise((resolve, reject) => {
              const form = document.querySelector(`[data-delete="${address_id}"] form`);
              // 提交form
              fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
              })
                .then(async (response) => {
                  // 关闭删除弹窗
                  _this.closeDeletePopup();

                  try {
                    // 使用当前页面地址作为数据源（如果有单独地址列表接口，可以替换为对应 URL）
                    const orderUrl = window.location.href;
                    const res = await fetch(`${orderUrl}`, { credentials: 'same-origin' });
                    if (!res.ok) throw new Error('Failed to load address list');

                    const responseText = await res.text();
                    const html = new DOMParser().parseFromString(responseText, 'text/html');

                    // 当前组件内的布局容器（包含列表 + 弹窗）
                    const currentLayout = _this.querySelector('.account-shipping-layout');
                    // 新 HTML 中对应的布局容器
                    const newLayout = html.querySelector('.account-shipping-layout');

                    if (currentLayout && newLayout) {
                      // 用新内容替换旧内容（列表 + 所有编辑/删除弹窗）
                      currentLayout.innerHTML = newLayout.innerHTML;
                      // 更新外部弹窗元素
                      _this.updateExternalPopups(html);
                      // 更新移动端新增按钮的显示状态
                      _this.updateMobileAddButton();
                      // 重新绑定事件（编辑 / 删除 / 新增 等）
                      _this.init();
                      _this.changeCountry();
                    }
                    
                    // 成功完成，resolve Promise
                    resolve();
                  } catch (err) {
                    console.error('刷新地址列表失败:', err);
                    if (window.pq && typeof window.pq.showToast === 'function') {
                      window.pq.showToast('error', window.i18n?.request_failed || 'Request failed');
                    }
                    // 出错时也要 resolve，让后续代码继续执行
                    resolve();
                  }
                })
                .catch((error) => {
                  // 显示错误信息
                  console.error('删除地址失败:', error);
                  if (window.pq && typeof window.pq.showToast === 'function') {
                    window.pq.showToast('error', window.i18n?.request_failed || 'Request failed');
                  }
                  // 关闭删除弹窗
                  _this.closeDeletePopup();
                  // 出错时也要 resolve，让后续代码继续执行
                  resolve();
                });
            });
          }

          editAddress(address_id) {
            const _this = this;
            if (!address_id) {
              address_id = 'newAddressForm';
            }
            this.currentPopupId = address_id;
            this.setAttribute('data-current-popup', address_id);
            const addressPopups = document.querySelectorAll('.address-popup');
            addressPopups.forEach((el) => {
              el.style.zIndex = '-99';
              el.style.opacity = '0';
            });
            const currentAddressPopup = document.querySelector(`[data-address_id="${address_id}"]`);
            if (currentAddressPopup) {
              currentAddressPopup.style.zIndex = '9999';
              currentAddressPopup.style.opacity = '1';
              
              // 自动滚动到页面顶部
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            } else {
              console.error('找不到弹窗元素:', address_id);
              return;
            }
            const countrySelectors = currentAddressPopup.querySelectorAll('.country-selector');

            // 用 JS 计算弹窗内容高度，给 account-shipping-layout / section 设明确 height 撑开
            const section = _this.querySelector('.account-shipping-section');
            const layout = _this.querySelector('.account-shipping-layout');
            const popupInner = currentAddressPopup.querySelector('.address-popup-inner');
            const syncLayoutHeight = () => {
              if (!section || !layout || !popupInner) return;

              // 检查是否为移动端（1024px以下）
              const isMobile = window.innerWidth <= 1024;

              if (isMobile) {
                // 移动端：清除所有强制设置的高度，让内容自然撑开
                layout.style.height = '';
                layout.style.minHeight = '';
                section.style.height = '';
                section.style.minHeight = '';
                return;
              }

              // 桌面端：当弹窗展开时，直接使用 address-popup-inner 的高度
              const popupH = popupInner.scrollHeight || popupInner.offsetHeight;
              layout.style.height = popupH + 'px';
              layout.style.minHeight = popupH + 'px';
              section.style.height = popupH + 'px';
              section.style.minHeight = popupH + 'px';
            };
            if (section && layout && popupInner) {
              requestAnimationFrame(() => {
                syncLayoutHeight();
                requestAnimationFrame(syncLayoutHeight);
              });
              setTimeout(syncLayoutHeight, 150);
              if (typeof ResizeObserver !== 'undefined') {
                if (_this._popupResizeObserver) {
                  _this._popupResizeObserver.disconnect();
                }
                _this._popupResizeObserver = new ResizeObserver(() => syncLayoutHeight());
                _this._popupResizeObserver.observe(popupInner);
              }
            }

            this.form = currentAddressPopup.querySelector(`#addressForm_${address_id}`);
            this.submitBtn = currentAddressPopup.querySelector('[type="submit"]');
            // 禁用浏览器默认校验
            this.form.setAttribute('novalidate', true);
            this.submitBtn.addEventListener('click', (e) => this.ClickSubmit(e));
            this.form.addEventListener('submit', (e) => e.preventDefault());

            // 重置表单到原始状态（确保显示的是原始数据，而不是上次编辑的数据）
            const form = currentAddressPopup.querySelector(`#addressForm_${address_id}`);
            if (form) {
              // 重置表单
              form.reset();

              // 判断是否为新建地址
              const isNewAddress = address_id === 'newAddressForm';

              // 重置国家选择器到原始值
              const countrySelect = form.querySelector('.country-selector');
              if (countrySelect) {
                let selectedCountry = '';
                let selectedCountryLabel = '';
                let selectedProvincesAttr = '';

                if (isNewAddress) {
                  // 新建地址：选中第一条数据
                  const firstOption = countrySelect.querySelector('option:not([value=""]):not([value="---"])');
                  if (firstOption) {
                    selectedCountry = firstOption.value;
                    selectedCountryLabel = firstOption.textContent;
                    selectedProvincesAttr = firstOption.getAttribute('data-provinces') || '';
                  }
                } else {
                  // 编辑地址：使用 data-country
                  const dataCountry = countrySelect.getAttribute('data-country');
                  if (dataCountry) {
                    selectedCountry = dataCountry;
                    const option = countrySelect.querySelector(`option[value="${dataCountry}"]`);
                    if (option) {
                      selectedCountryLabel = option.textContent;
                      selectedProvincesAttr = option.getAttribute('data-provinces') || '';
                    }
                  }
                }

                // 设置选中的国家
                if (selectedCountry) {
                  countrySelect.value = selectedCountry;

                  // 重置国家下拉的显示文本
                  const countryTrigger = form.querySelector('.address-select-trigger-country');
                  if (countryTrigger) {
                    const countryLabelSpan = countryTrigger.querySelector('.address-select-label');
                    if (countryLabelSpan) {
                      countryLabelSpan.textContent = selectedCountryLabel;
                    }

                    // 添加 is-filled 状态到国家的 address_input_container
                    const countryInputContainer = countryTrigger.closest('.address_input_container');
                    if (countryInputContainer) {
                      countryInputContainer.classList.add('is-filled');
                    }

                    // 手动调用 address-input 组件的 updateProvinceOptions 方法来更新省份列表
                    const addressInputComponent = countryTrigger.closest('address-input');
                    if (addressInputComponent && typeof addressInputComponent.updateProvinceOptions === 'function') {
                      addressInputComponent.updateProvinceOptions(selectedProvincesAttr);
                    }
                  }

                  // 最后触发 change 事件
                  countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }

              // 重置省份选择器到原始值
              const provinceSelect = form.querySelector('.province-selector');
              const provinceTrigger = form.querySelector('.address-select-trigger-province');
              const provinceContainer = provinceTrigger ? provinceTrigger.closest('.address_input_container') : null;

              if (provinceSelect && provinceTrigger && !isNewAddress) {
                const dataProvince = provinceSelect.getAttribute('data-country_prov');
                // 如果有原始省份数据，需要恢复显示（仅用于编辑地址）
                if (dataProvince && dataProvince !== '---' && dataProvince.trim() !== '') {
                  // 检查原始国家是否有省份数据

                  const dataCountry = countrySelect.getAttribute('data-country');
                  if (dataCountry) {
                    // 从国家的 options 中查找对应的省份数据
                    const countryOption = countrySelect.querySelector(`option[value="${dataCountry}"]`);
                    if (countryOption) {
                      const provincesAttr = countryOption.getAttribute('data-provinces');
                      if (provincesAttr) {
                        try {
                          const provinces = JSON.parse(provincesAttr);
                          if (provinces && Array.isArray(provinces) && provinces.length > 0) {
                            // 原始国家有省份数据，恢复省份选择器
                            // 清空旧选项
                            provinceSelect.innerHTML = '';
                            const provinceOptionsContainer = form.querySelector('[data-address-province-options]');
                            if (provinceOptionsContainer) {
                              provinceOptionsContainer.innerHTML = '';
                            }

                            // 生成省份选项
                            const provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');
                            let foundProvince = false;

                            for (let i = 0; i < provinces.length; i++) {
                              const province = provinces[i];
                              const code = province[0];
                              const name = province[1];

                              // 添加到原生 select
                              const option = document.createElement('option');
                              option.value = code;
                              option.textContent = name;
                              provinceSelect.appendChild(option);

                              // 添加到自定义下拉列表
                              if (provinceOptionsContainer) {
                                const li = document.createElement('li');
                                li.className = 'select-options-item';
                                li.setAttribute('data-value', code);
                                li.textContent = name;
                                provinceOptionsContainer.appendChild(li);
                              }

                              // 如果匹配原始省份值，设置为选中
                              if (code === dataProvince) {
                                provinceSelect.value = code;
                                if (provinceLabelSpan) {
                                  provinceLabelSpan.textContent = name;
                                }
                                foundProvince = true;
                              }
                            }

                            // 如果没有找到匹配的省份，选择第一个
                            if (!foundProvince && provinces.length > 0) {
                              const firstProvince = provinces[0];
                              provinceSelect.value = firstProvince[0];
                              if (provinceLabelSpan) {
                                provinceLabelSpan.textContent = firstProvince[1];
                              }
                            }

                            // 显示省份 trigger 和容器
                            if (provinceContainer) {
                              provinceContainer.style.display = '';
                            }
                            provinceTrigger.style.display = '';

                            // 触发 change 事件
                            provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
                          }
                        } catch (e) {
                          console.error('解析省份数据失败:', e);
                        }
                      }
                    }
                  }
                }
              }
            }

            // 更新所有 address-input 组件的填充状态
            // 使用 setTimeout 确保 DOM 已经完全渲染
            setTimeout(function () {
              const addressInputs = currentAddressPopup.querySelectorAll('address-input');
              addressInputs.forEach(function (inputComponent) {
                if (inputComponent && typeof inputComponent.updateFilledState === 'function') {
                  inputComponent.updateFilledState();
                }
              });
              if (typeof syncLayoutHeight === 'function') syncLayoutHeight();
            }, 100);
          }

          cancelAddress() {
            const _this = this;
            if (_this._popupResizeObserver) {
              _this._popupResizeObserver.disconnect();
              _this._popupResizeObserver = null;
            }
            const section = _this.querySelector('.account-shipping-section');
            const layout = _this.querySelector('.account-shipping-layout');

            // 检查是否为移动端
            const isMobile = window.innerWidth <= 1024;

            if (!isMobile) {
              // 只在桌面端重置高度，移动端保持CSS设置
              if (section) {
                section.style.height = '';
                section.style.minHeight = '';
              }
              if (layout) {
                layout.style.height = '';
                layout.style.minHeight = '';
              }
            }
            const addressPopups = document.querySelectorAll('.address-popup');
            addressPopups.forEach((el) => {
              el.style.display = 'none';
              el.style.display = 'flex';
              el.style.zIndex = '-99';
              el.style.opacity = '0';
              const form = el.querySelector('form');
              if (form) form.reset();

              const requiredFields = el.querySelectorAll('[required]');
              requiredFields.forEach((field) => {
                _this.resetFieldStatus(field);
              });

              // 移除按钮的 loading class
              const submitBtn = el.querySelector('.address_save_btn');
              if (submitBtn) {
                submitBtn.classList.remove('loading');
              }
            });
          }
          validateForm() {
            let isValid = true;
            const errors = [];

            // 校验所有必填字段
            this.form.querySelectorAll('[required]').forEach((field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });

            this.errors = errors;
            return isValid;
          }
          validateField(field) {
            const value = field.value;
            let isValid = true;

            // 必填校验
            if (field.required && (!value || value === '' || value === '---')) {
              isValid = false;
            }

            // // 手机号校验
            // if (field.name === 'address[phone]' && value) {
            //   isValid = this.validatePhone(value);
            // }

            // // 邮编校验
            // if (field.name === 'address[zip]' && value) {
            //   isValid = this.validateZip(value);
            // }

            // 更新字段状态
            this.updateFieldStatus(field, isValid);
            return isValid;
          }

          resetFieldStatus(field) {
            const addressInputPlaceholder = field.parentElement.querySelector('.address_input_placeholder');
            // 获取父元素为 address_input_container的元素
            const addressInputContainer = field.closest('.address_input_container');
            // 获取与addressInputContainer同级的 error-message元素
            if (addressInputContainer) {
              const errorMessage = addressInputContainer.parentElement.querySelector('.error-message');
              if (addressInputPlaceholder) {
                addressInputPlaceholder.style.color = '#666666';
              }
              addressInputContainer.classList.remove('border-[#FC2323]');
              addressInputContainer.classList.add('border-[#D9D9D9]');
              if (errorMessage) errorMessage.classList.add('hidden');
            }
          }

          updateFieldStatus(field, isValid) {
            // 获取与field同级的 address_input_placeholder元素
            const addressInputPlaceholder = field.parentElement.querySelector('.address_input_placeholder');
            // 获取父元素为 address_input_container的元素
            const addressInputContainer = field.closest('.address_input_container');

            // 获取与addressInputContainer同级的 error-message元素
            const errorMessage = addressInputContainer?.parentElement?.querySelector('.error-message');

            // 对于 select 元素（国家/省份），需要给触发器添加错误样式
            const selectTrigger = field.parentElement.querySelector(
              '.address-select-trigger, .address-select-trigger-country, .address-select-trigger-province'
            );

            if (!isValid) {
              if (addressInputContainer) {
                addressInputContainer.classList.remove('border-[#D9D9D9]');
                addressInputContainer.classList.add('border-[#FC2323]');
                addressInputContainer.classList.add('field-error');
              }
              if (addressInputPlaceholder) {
                addressInputPlaceholder.style.color = '#FC2323';
              }
              if (selectTrigger) {
                selectTrigger.style.borderColor = '#FC2323';
              }
              if (errorMessage) errorMessage.classList.remove('hidden');
            } else {
              if (addressInputContainer) {
                addressInputContainer.classList.remove('border-[#FC2323]');
                addressInputContainer.classList.add('border-[#D9D9D9]');
                addressInputContainer.classList.remove('field-error');
              }
              if (addressInputPlaceholder) {
                addressInputPlaceholder.style.color = '#737373';
              }
              if (selectTrigger) {
                selectTrigger.style.borderColor = '#D9D9D9';
              }
              if (errorMessage) errorMessage.classList.add('hidden');
            }
          }

          getErrorMessage(field) {
            const fieldName = field.name;

            // 自定义错误信息
            const customMessage = field.dataset.errorMessage;
            if (customMessage) return customMessage;

            // 默认错误信息
            const messages = {
              'address[name]': '请输入姓名',
              'address[phone]': '请输入有效的手机号',
              'address[email]': '请输入有效的邮箱地址',
              'address[zip]': '请输入有效的邮政编码',
              'address[country]': '请选择国家/地区',
              'address[province]': '请选择省份',
              'address[city]': '请选择城市',
              'address[address1]': '请输入详细地址',
            };

            return messages[fieldName] || '此字段不能为空';
          }

          ClickSubmit(e) {
            e.preventDefault();
            e.stopPropagation();
            this.handleSubmit(e);
          }

          handleSubmit(e) {
            e.preventDefault();
            const _this = this;

            let isValid = true;
            this.form.querySelectorAll('[required]').forEach((field) => {
              // 任何一个必填项校验失败，都标记为整体无效
              if (!_this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }

            // 显示加载状态
            const rotateIcon = this.submitBtn.querySelector('.rotate_icon');
            const loadingText = this.submitBtn.querySelector('.loading-button-text');

            // 给 address_save_btn 添加 loading class
            if (this.submitBtn && this.submitBtn.classList.contains('address_save_btn')) {
              this.submitBtn.classList.add('loading');
            }

            if (rotateIcon) {
              rotateIcon.classList.remove('hidden');
              rotateIcon.classList.add('flex');
            }
            if (loadingText) {
              loadingText.classList.add('hidden');
              loadingText.classList.remove('flex');
            }

            fetch(this.form.action, {
              method: 'POST',
              body: new FormData(this.form),
              credentials: 'same-origin',
            })
              .then(async (response) => {
                // loading图标隐藏
                const rotateIcon = _this.submitBtn.querySelector('.rotate_icon');
                const loadingText = _this.submitBtn.querySelector('.loading-button-text');

                // 移除 address_save_btn 的 loading class
                if (_this.submitBtn && _this.submitBtn.classList.contains('address_save_btn')) {
                  _this.submitBtn.classList.remove('loading');
                }

                if (rotateIcon) {
                  rotateIcon.classList.remove('flex');
                  rotateIcon.classList.add('hidden');
                }
                if (loadingText) {
                  loadingText.classList.add('flex');
                  loadingText.classList.remove('hidden');
                }
                _this.cancelAddress();

                // 通过 currentPopupId 拿到当前编辑的 address_id
                const addressId = _this.currentPopupId;

                try {
                  // 使用当前页面地址作为数据源（如果有单独地址列表接口，可以替换为对应 URL）
                  const orderUrl = window.location.href;
                  const response = await fetch(`${orderUrl}`, {
                    credentials: 'same-origin',
                  });
                  const responseText = await response.text();
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  // 当前组件内的布局容器（包含列表 + 弹窗）
                  const currentLayout = _this.querySelector('.account-shipping-layout');
                  // 新 HTML 中对应的布局容器
                  const newLayout = html.querySelector('.account-shipping-layout');

                  if (currentLayout && newLayout) {
                    // 用新内容替换旧内容（列表 + 所有编辑/删除弹窗）
                    currentLayout.innerHTML = newLayout.innerHTML;
                    // 更新外部弹窗元素
                    _this.updateExternalPopups(html);
                    // 更新移动端新增按钮的显示状态
                    _this.updateMobileAddButton();
                    // 重新绑定事件（编辑 / 删除 / 新增等）
                    _this.init();
                    _this.changeCountry();
                  }
                } catch (err) {
                  console.error('刷新地址列表失败:', err);
                  if (window.pq && typeof window.pq.showToast === 'function') {
                    window.pq.showToast('error', window.i18n?.request_failed || 'Request failed');
                  }
                }
              })
              .catch((error) => {
                console.error('提交地址失败:', error);

                // 移除按钮的 loading class
                const rotateIcon = _this.submitBtn.querySelector('.rotate_icon');
                const loadingText = _this.submitBtn.querySelector('.loading-button-text');

                if (rotateIcon) {
                  rotateIcon.classList.remove('flex');
                  rotateIcon.classList.add('hidden');
                }
                if (loadingText) {
                  loadingText.classList.add('flex');
                  loadingText.classList.remove('hidden');
                }

                // 移除 address_save_btn 的 loading class
                const currentPopup = document.querySelector(`[data-address_id="${_this.currentPopupId}"]`);
                if (currentPopup) {
                  const submitBtn = currentPopup.querySelector('.address_save_btn');
                  if (submitBtn) {
                    submitBtn.classList.remove('loading');
                  }
                }
              });
          }

          disconnectedCallback() {
            // 清理窗口大小变化监听器
            if (this.resizeHandler) {
              window.removeEventListener('resize', this.resizeHandler);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-global-toast"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('custom-global-toast')) {
      customElements.define(
        'custom-global-toast',
        class GlobalToast extends HTMLElement {
          constructor() {
            super();
            this.container = this.querySelector('div');
            this.template = this.querySelector('.global-toast__template');
            this.toasts = new Map();
            this.counter = 0;

            if (!window.pqToast) window.pqToast = {};
            window.pqToast.showToast = this.showToast.bind(this);
          }

          connectedCallback() {
            this.init();
          }

          init() {}

          showToast(type, message, duration = 2000) {
            const id = `toast-${this.counter++}`;

            // 创建新的toast元素
            const newToast = this.createToast(id, type, message);
            this.container.appendChild(newToast);

            // 存储toast引用
            this.toasts.set(id, {
              element: newToast,
              timer: null,
            });

            // 显示动画 - 使用CSS transition
            newToast.style.opacity = '0';
            newToast.style.transform = 'translateY(-15px)';

            // 强制重绘
            newToast.offsetHeight;

            // 应用显示样式
            newToast.style.opacity = '1';
            newToast.style.transform = 'translateY(0)';
            newToast.style.transition = 'opacity 0.25s ease, transform 0.25s ease';

            // 动画完成后设置自动关闭定时器
            setTimeout(() => {
              const timer = setTimeout(() => {
                this.removeToast(id);
              }, duration);

              // 更新计时器引用
              if (this.toasts.has(id)) {
                this.toasts.get(id).timer = timer;
              }
            }, 250); // 等待动画完成

            return id; // 返回ID，可用于手动关闭
          }

          removeToast(id) {
            const toast = this.toasts.get(id);
            if (!toast) return;

            // 清除定时器
            if (toast.timer) {
              clearTimeout(toast.timer);
            }

            // 隐藏动画 - 使用CSS transition
            toast.element.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
            toast.element.style.opacity = '0';
            toast.element.style.transform = 'translateY(-15px)';

            // 动画完成后移除元素
            setTimeout(() => {
              if (toast.element.parentNode) {
                toast.element.parentNode.removeChild(toast.element);
              }
              // 从Map中移除
              this.toasts.delete(id);
            }, 250); // 等待动画完成
          }

          createToast(id, type, message) {
            // 克隆模板
            const clone = this.template.content.cloneNode(true).firstElementChild;

            // 设置ID和数据属性
            clone.id = id;
            clone.dataset.type = type;

            // 设置消息内容
            clone.querySelector('.global-toast__message').innerHTML = message;

            // 设置图标和背景颜色
            const icons = clone.querySelectorAll('.global-toast__icon i');
            icons.forEach((icon) => icon.classList.add('hidden'));

            let backgroundColor;
            switch (type) {
              case 'success':
                icons[0].classList.remove('hidden'); // success图标
                backgroundColor = '#E5F3F0';
                break;
              case 'warning':
                icons[1].classList.remove('hidden'); // warning图标
                backgroundColor = '#FFF8E6';
                break;
              case 'error':
                icons[2].classList.remove('hidden'); // error图标
                backgroundColor = '#FFE4E4';
                break;
            }

            clone.style.backgroundColor = backgroundColor;

            return clone;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-modal')) {
      // 创建弹窗根容器
      const createModalRoot = () => {
        const existingRoot = document.getElementById('global-modal__root');
        if (existingRoot) return existingRoot;

        const root = document.createElement('div');
        root.id = 'global-modal__root';
        root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
        document.body.appendChild(root);
        return root;
      };

      customElements.define(
        'global-modal',
        class GlobalModal extends HTMLElement {
          // 基础索引
          static baseZIndex = 501;
          // 实例集合
          static instances = new Set();
          // 弹窗根容器
          static root = null;

          // 获取或创建根容器
          static getRoot() {
            if (!this.root) {
              this.root = createModalRoot();
            }
            return this.root;
          }

          constructor() {
            super();
            this.modalId = this.dataset.modalId;
            this.lazyLoad = this.dataset.lazyLoad == 'true';
            this.closeOnClickMask = this.dataset.closeOnClickMask == 'true';

            this.containerEle = this.querySelector('.global-modal__container');
            this.wrapperEle = this.querySelector('.global-modal__wrapper');
            this.closeBtnEle = this.querySelector('.global-modal__close_btn');
            this.isRendered = false;

            this.isOpen = false;
            this.level = 0;
            this.isMoving = false;
            GlobalModal.instances.add(this);
          }

          connectedCallback() {
            if (this.parentElement?.id === 'global-modal__root') return;
            this.templateContent = document.getElementById(`modal-template-${this.modalId}`);

            this.isMoving = true;
            // 创建占位符
            this.placeholder = document.createElement('div');
            this.placeholder.dataset.modalPlaceholder = this.modalId;

            // 保存原始位置并移动到根容器
            this.parentElement.insertBefore(this.placeholder, this);
            GlobalModal.getRoot().appendChild(this);

            this.isMoving = false;

            this.init();
          }

          init() {
            if (this.wrapperEle && this.closeOnClickMask) {
              this.wrapperEle.addEventListener('click', this.handleWrapperClick.bind(this));
            }
            if (this.closeBtnEle) {
              this.closeBtnEle.addEventListener('click', this.handleCloseBtnClick.bind(this));
            }
          }

          handleWrapperClick(event) {
            if (event.target == this.wrapperEle) {
              const currentLevel = this.level;
              Array.from(GlobalModal.instances)
                .filter((modal) => modal.level >= currentLevel && modal.isOpen)
                .forEach((modal) => modal.close());
            }
          }

          handleCloseBtnClick() {
            this.close();
          }

          // 打开弹窗
          open() {
            if (!this.containerEle || this.isOpen) return;

            // 在弹窗打开前按需渲染内容
            if (!this.isRendered && this.lazyLoad && this.templateContent) {
              const contentContainer = this.wrapperEle || this.containerEle;
              // 将模板内容添加到弹窗中
              if (contentContainer && this.templateContent.content) {
                // 使用深度克隆以确保所有子元素和属性都被复制
                const clone = document.importNode(this.templateContent.content, true);
                contentContainer.appendChild(clone);

                // 重新获取可能通过模板添加的关闭按钮
                if (!this.closeBtnEle) {
                  this.closeBtnEle = this.querySelector('.global-modal__close_btn');
                  if (this.closeBtnEle) {
                    this.closeBtnEle.addEventListener('click', this.handleCloseBtnClick.bind(this));
                  }
                }
                this.isRendered = true;
              }
            }

            // 获取当前打开的所有弹窗
            const openModals = Array.from(GlobalModal.instances).filter((modal) => modal.isOpen);
            this.level = openModals.length;

            this.containerEle.style.zIndex = GlobalModal.baseZIndex + this.level * 2 + 1;
            this.dataset.isOpen = 'true';
            if (window.pq && window.pq.scrollDisable) {
              window.pq.scrollDisable();
            } else if (window.pq && window.pq.disableScroll) {
              window.pq.disableScroll();
            }

            requestAnimationFrame(() => {
              this.containerEle.style.visibility = 'visible';
              this.containerEle.style.opacity = 1;

              // 重排line-clamp元素，兼容ipad端省略不生效
              const lineClamps = this.containerEle.querySelectorAll('[class*="line-clamp-"]');
              lineClamps.forEach((el) => {
                el.style.display = 'none';
                el.offsetHeight;
                el.style.display = '';
              });

              this.isOpen = true;
              this.dispatchEvent(
                new CustomEvent('modal-opened', {
                  detail: {
                    modalId: this.modalId,
                    level: this.level,
                    wrapperEle: this.wrapperEle,
                  },
                })
              );
            });
          }

          // 关闭弹窗
          close() {
            if (!this.containerEle || !this.isOpen) return;

            Array.from(GlobalModal.instances)
              .filter((modal) => modal.level > this.level && modal.isOpen)
              .forEach((modal) => modal.close());
            delete this.dataset.isOpen;

            // 检查是否还有其他打开弹窗
            const hasOpenModals = Array.from(GlobalModal.instances).some((modal) => modal !== this && modal.isOpen);
            if (!hasOpenModals) {
              if (window.pq && window.pq.enableScroll) {
                window.pq.enableScroll();
              } else if (window.pq && window.pq.enableScroll) {
                window.pq.enableScroll();
              }
            }

            this.containerEle.style.visibility = 'hidden';
            this.containerEle.style.opacity = 0;

            this.isOpen = false;

            // 触发关闭事件
            this.dispatchEvent(
              new CustomEvent('modal-closed', {
                detail: {
                  modalId: this.modalId,
                  level: this.level,
                  wrapperEle: this.wrapperEle,
                },
              })
            );
          }

          disconnectedCallback() {
            if (this.isMoving) return;
            if (this.wrapperEle) {
              this.wrapperEle.removeEventListener('click', this.handleWrapperClick.bind(this));
            }
            if (this.closeBtnEle) {
              this.closeBtnEle.removeEventListener('click', this.handleCloseBtnClick.bind(this));
            }
            this.placeholder?.remove();
            GlobalModal.instances.delete(this);
          }
        }
      );
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (window.ModalController) return;

    // 弹窗控制器
    class ModalController {
      #modals = new Map();
      constructor() {
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            const openModals = Array.from(document.querySelectorAll('global-modal[data-is-open]'))
              .filter((modal) => modal.isOpen)
              .sort((a, b) => b.level - a.level);
            openModals[0]?.close();
          }
        });
      }

      register(modalId, { onOpen, onClose } = {}) {
        const modal = document.querySelector(`global-modal[data-modal-id="${modalId}"]`);
        if (!modal) return;

        if (onOpen) modal.addEventListener('modal-opened', (event) => onOpen(event.detail.wrapperEle));
        if (onClose) modal.addEventListener('modal-closed', (event) => onClose(event.detail.wrapperEle));

        this.#modals.set(modalId, modal);
        return modal;
      }

      getModal(modalId) {
        return this.#modals.get(modalId);
      }

      open(modalId) {
        this.#modals.get(modalId)?.open();
      }

      // 关闭指定弹窗
      close(modalId) {
        this.#modals.get(modalId)?.close();
      }
    }
    window.ModalController = ModalController;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-change-password"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-change-password')) {
      customElements.define(
        'pq-account-change-password',
        class PqAccountChangePassword extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initForm();
            this.submitForm();
            this.initPasswordEye();
          }
          // 表单初始化
          initForm() {
            // 密码校验 防抖处理
            const password = this.querySelector('[data-type="password"]');
            const passwordInput =
              password?.querySelector('.pq-custom-form-container-input-wrapper .pq-custom-form-container-input') ||
              password?.querySelector('.pq-custom-form-container-input');
            if (password && passwordInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordValidate = window.pq.debounce((value) => {
                this.validate('password', password, value);
              }, 300);

              passwordInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordValidate(value);
              });
            }
            // 确认密码校验 防抖处理
            const passwordConfirmation = this.querySelector('[data-type="password_confirmation"]');
            const passwordConfirmationInput = passwordConfirmation?.querySelector('.pq-custom-form-container-input');
            if (passwordConfirmation && passwordConfirmationInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordConfirmationValidate = window.pq.debounce((value) => {
                this.validate('password_confirmation', passwordConfirmation, value);
              }, 300);
              passwordConfirmationInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordConfirmationValidate(value);
              });
            }
          }
          // 校验逻辑
          validate(type, container, value) {
            if (!container) {
              return;
            }

            let regular = null;
            switch (type) {
              case 'password':
                regular = window.pq?.rule?.password;
                break;
              case 'password_confirmation':
                regular = window.pq?.rule?.password;
                break;
              default:
                break;
            }

            if (!regular) {
              console.warn(`验证规则未找到: ${type}`);
              return;
            }

            const isValid = regular.test(value);
            // 为空也显示错误
            container.setAttribute('data-error', isValid && value ? 'false' : 'true');
          }
          // 提交表单
          submitForm() {
            const button = this.querySelector('.pq-account-change-password__submit');
            if (button) {
              button.addEventListener('click', async (e) => {
                e.preventDefault();
                const password = this.querySelector('[data-type="password"]');
                const passwordConfirmation = this.querySelector('[data-type="password_confirmation"]');
                // 同时执行一遍校验
                this.validate('password', password, password.querySelector('.pq-custom-form-container-input').value);
                this.validate(
                  'password_confirmation',
                  passwordConfirmation,
                  passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                );
                if (
                  password.getAttribute('data-error') === 'true' ||
                  passwordConfirmation.getAttribute('data-error') === 'true'
                ) {
                  return;
                }
                if (
                  password.querySelector('.pq-custom-form-container-input').value !==
                  passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                ) {
                  window.pqToast.showToast('error', window.pqI18n.error_10101416);
                  return;
                }
                try {
                  button.setAttribute('data-loading', 'true');
                  if (!this.rsa) {
                    await this.fetchRsa();
                  }
                  const encryptedPassword = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    password.querySelector('.pq-custom-form-container-input').value
                  );
                  const encryptedPasswordConfirmation = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                  );
                  const data = {
                    email: this.getAttribute('data-email'),
                    password: encryptedPassword,
                    confirmPassword: encryptedPasswordConfirmation,
                    sign: this.getAttribute('data-sign'),
                  };
                  const res = await this.asyncPassword(data);
                  if (res.code === 200) {
                    window.pq.closeAccountDrawer();
                    window.pqToast.showToast('success', window.pqI18n.change_password_success);
                    if (res.data?.referralInvitedReward) {
                      window.pq.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.pq.setLocalStorage('pqUserInfo', res.data);
                    window.pq.setLocalStorage('pqToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('login error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          async asyncPassword(data) {
            const url = '/shopify/auth/login/security';
            const res = await window.pq.http.post(url, {
              data,
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101107) {
              throw new Error(window.pqI18n.error_10101107);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          async fetchRsa() {
            const url = '/shopify/auth/rsa';
            const { data } = await window.pq.http.get(url);
            this.rsa = data.publicKey;
          }
          initPasswordEye() {
            const passwordContainers = this.querySelector('[data-type="password"]');
            const input = passwordContainers.querySelector('.pq-custom-form-container-input');
            const eyeCloseDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-close');
            const eyeOpenDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-open');
            // 点击后修改data-plaintext属性
            eyeCloseDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'true');
              input.setAttribute('type', 'text');
            });
            eyeOpenDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'false');
              input.setAttribute('type', 'password');
            });
            // 确认密码
            const passwordConfirmationContainers = this.querySelector('[data-type="password_confirmation"]');
            const passwordConfirmationInput = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input'
            );
            const passwordConfirmationEyeCloseDom = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input-icon-close'
            );
            const passwordConfirmationEyeOpenDom = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input-icon-open'
            );
            // 点击后修改data-plaintext属性
            passwordConfirmationEyeCloseDom.addEventListener('click', () => {
              passwordConfirmationContainers.setAttribute('data-plaintext', 'true');
              passwordConfirmationInput.setAttribute('type', 'text');
            });
            passwordConfirmationEyeOpenDom.addEventListener('click', () => {
              passwordConfirmationContainers.setAttribute('data-plaintext', 'false');
              passwordConfirmationInput.setAttribute('type', 'password');
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-forgot-password-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-forgot-password-drawer')) {
      customElements.define(
        'pq-account-forgot-password-drawer',
        class PqAccountForgotPasswordDrawer extends HTMLElement {
          constructor() {
            super();
          }

          static get observedAttributes() {
            return ['data-type'];
          }
          attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-type') {
              this.initType(newValue);
            }
          }
          connectedCallback() {
            console.log('8888 connectedCallback');
            this.init();
          }
          init() {
            this.initType(this.getAttribute('data-type'));
            this.initForm();
            this.submitForm();
            this.initSuccess();
            this.initBack();
            this.initClose();
          }
          initClose() {
            const pqAccountForgotPasswordDrawerClose = this.querySelector(
              '.pq-account-forgot-password-drawer__container-header-close'
            );
            if (pqAccountForgotPasswordDrawerClose) {
              pqAccountForgotPasswordDrawerClose.addEventListener('click', () => {
                this.setAttribute('data-show', 'false');
                // 宽度大于640px时，关闭账号弹窗
                if (window.innerWidth > 640) {
                  window.pq.closeAccountDrawer();
                }
              });
            }
          }
          initBack() {
            const pqAccountForgotPasswordDrawerBack = this.querySelector(
              '.pq-account-forgot-password-drawer__container-header-back'
            );
            if (pqAccountForgotPasswordDrawerBack) {
              pqAccountForgotPasswordDrawerBack.addEventListener('click', () => {
                if (this.getAttribute('data-type') === 'default') {
                  window.pq.openAccountDrawer('login-register', 'login');
                  this.setAttribute('data-show', 'false');
                } else {
                  this.setAttribute('data-type', 'default');
                }
              });
            }
          }
          initType(type) {
            const pqAccountForgotPasswordContent = this.querySelectorAll('.pq-account-forgot-password-drawer__content');
            pqAccountForgotPasswordContent.forEach((item) => {
              item.classList.remove('active');
            });
            const pqAccountForgotPasswordContentActive = this.querySelector(
              `.pq-account-forgot-password-drawer__content[data-type="${type}"]`
            );
            pqAccountForgotPasswordContentActive.classList.add('active');
          }
          // 表单初始化
          initForm() {
            // 邮箱校验 防抖处理
            const email = this.querySelector('[data-type="email"]');
            console.log('8888 email', email);
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            if (email && emailInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedEmailValidate = window.pq.debounce((value) => {
                this.validate('email', email, value);
              }, 300);

              emailInput.addEventListener('input', (e) => {
                const value = e.target.value.trim();
                debouncedEmailValidate(value);
              });
            }
          }
          // 校验逻辑
          validate(type, container, value) {
            if (!container) {
              return;
            }

            let regular = null;
            switch (type) {
              case 'email':
                regular = window.pq?.rule?.email;
                break;
              default:
                break;
            }

            if (!regular) {
              console.warn(`验证规则未找到: ${type}`);
              return;
            }

            const isValid = regular.test(value);
            // 为空也显示错误
            container.setAttribute('data-error', isValid && value ? 'false' : 'true');
          }
          // 提交表单
          submitForm() {
            const button = this.querySelector('.pq-account-forgot-password-drawer__default-submit');
            if (button) {
              button.addEventListener('click', async (e) => {
                e.preventDefault();
                const email = this.querySelector('[data-type="email"]');
                // 同时执行一遍校验
                this.validate('email', email, email.querySelector('.pq-custom-form-container-input').value);
                if (email.getAttribute('data-error') === 'true') {
                  return;
                }
                try {
                  button.setAttribute('data-loading', 'true');
                  const emailValue = email.querySelector('.pq-custom-form-container-input').value;
                  const data = {
                    email: emailValue,
                    type: 2,
                  };
                  const res = await this.sendCode(data);
                  if (res.code === 200) {
                    this.setAttribute('data-type', 'success');
                    this.setEmail(emailValue);
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('forgot password error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          setEmail(email) {
            this.setAttribute('data-email', email);
            const emailElement = this.querySelector(
              '[data-type="success"] .pq-account-forgot-password-drawer__success-header-desc-email'
            );
            if (emailElement) {
              emailElement.innerHTML = email;
            }
          }
          initSuccess() {
            const button = this.querySelector('.pq-account-forgot-password-drawer__success-footer-button');
            const notReceiveEmailButton = this.querySelector(
              '.pq-account-forgot-password-drawer__success-footer-desc-button'
            );
            if (button) {
              button.addEventListener('click', (e) => {
                window.pq.openAccountDrawer('login-register', 'login');
                this.setAttribute('data-show', 'false');
              });
            }
            if (notReceiveEmailButton) {
              notReceiveEmailButton.addEventListener('click', (e) => {
                window.pq.openChatApp();
              });
            }
          }
          async sendCode(data) {
            const url = '/shopify/auth/send-verification-code';
            const res = await window.pq.http.post(url, {
              data,
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101410) {
              throw new Error(window.pqI18n.error_10101410);
            } else if (res.code === 10101404) {
              throw new Error(window.pqI18n.error_10101404);
            } else if (res.code === 10101409) {
              throw new Error(window.pqI18n.error_10101409);
            } else if (res.code === 10101109) {
              throw new Error(window.pqI18n.error_10101109_login);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-login-register"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-login-register')) {
      customElements.define(
        'pq-account-login-register',
        class PqAccountLoginRegister extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          static get observedAttributes() {
            return ['data-type'];
          }
          attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-type') {
              this.switchTab(newValue);
            }
          }
          init() {
            this.initTabs();
          }
          initTabs() {
            const tabs = this.querySelectorAll('.pq-account-login-register__tabs-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.setAttribute('data-type', tab.getAttribute('data-type'));
              });
            });
          }
          switchTab(type) {
            // 如果是登录或者注册页面，修改对应type时，同步将路径修改为对应的type，但是不发生跳转，类似https://dev-askstarry.myshopify.com/account/login
            if (this.getAttribute('data-template') === 'login' || this.getAttribute('data-template') === 'register') {
              window.history.pushState({}, '', `/account/${type}`);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-login"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-login')) {
      customElements.define(
        'pq-account-login',
        class PqAccountLogin extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initForm();
            this.submitForm();
            this.initPasswordEye();
            this.initForgotPassword();
          }
          initForgotPassword() {
            const forgotPassword = this.querySelector('.pq-account-login__form-forgot');
            if (forgotPassword) {
              forgotPassword.addEventListener('click', (e) => {
                console.log('8888 initForgotPassword');
                window.pq.openAccountDrawer('login-register');
                document.querySelector('pq-account-forgot-password-drawer').setAttribute('data-show', 'true');
                document.querySelector('pq-account-forgot-password-drawer').setAttribute('data-type', 'default');
                document.querySelector('pq-account-drawer').setAttribute('data-forgot-password', 'true');
              });
            }
          }
          // 表单初始化
          initForm() {
            // 邮箱校验 防抖处理
            const email = this.querySelector('[data-type="email"]');
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            if (email && emailInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedEmailValidate = window.pq.debounce((value) => {
                this.validate('email', email, value);
              }, 300);

              emailInput.addEventListener('input', (e) => {
                const value = e.target.value.trim();
                debouncedEmailValidate(value);
              });
            }

            // 密码校验 防抖处理
            const password = this.querySelector('[data-type="password"]');
            const passwordInput =
              password?.querySelector('.pq-custom-form-container-input-wrapper .pq-custom-form-container-input') ||
              password?.querySelector('.pq-custom-form-container-input');
            if (password && passwordInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordValidate = window.pq.debounce((value) => {
                this.validate('password', password, value);
              }, 300);

              passwordInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordValidate(value);
              });
            }
          }
          // 校验逻辑
          validate(type, container, value) {
            if (!container) {
              return;
            }

            let regular = null;
            switch (type) {
              case 'email':
                regular = window.pq?.rule?.email;
                break;
              case 'password':
                regular = window.pq?.rule?.password;
                break;
              default:
                break;
            }

            if (!regular) {
              console.warn(`验证规则未找到: ${type}`);
              return;
            }

            const isValid = regular.test(value);
            // 为空也显示错误
            container.setAttribute('data-error', isValid && value ? 'false' : 'true');
          }
          // 提交表单
          submitForm() {
            const button = this.querySelector('.pq-account-login__submit');
            if (button) {
              button.addEventListener('click', async (e) => {
                e.preventDefault();
                const email = this.querySelector('[data-type="email"]');
                const password = this.querySelector('[data-type="password"]');
                // 同时执行一遍校验
                this.validate('email', email, email.querySelector('.pq-custom-form-container-input').value);
                this.validate('password', password, password.querySelector('.pq-custom-form-container-input').value);
                if (email.getAttribute('data-error') === 'true' || password.getAttribute('data-error') === 'true') {
                  return;
                }
                try {
                  button.setAttribute('data-loading', 'true');
                  const urlParams = new URLSearchParams(window.location.search);
                  let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
                  if (redirectUrl === '/') {
                    if (window.location.href.includes('/login')) {
                      redirectUrl = window.location.origin;
                    } else {
                      redirectUrl = window.location.href;
                    }
                  } else {
                    redirectUrl = window.location.origin + redirectUrl;
                  }
                  if (!this.rsa) {
                    await this.fetchRsa();
                  }
                  const encryptedPassword = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    password.querySelector('.pq-custom-form-container-input').value
                  );
                  const emailValue = email.querySelector('.pq-custom-form-container-input').value;
                  const data = {
                    email: emailValue,
                    password: encryptedPassword,
                    returnTo: redirectUrl,
                    loginType: 1,
                  };
                  const res = await this.login(data);
                  if (res.code === 200) {
                    window.pq.closeAccountDrawer();
                    window.pqToast.showToast('success', window.pqI18n.common_welcome_back);
                    if (res.data?.referralInvitedReward) {
                      window.pq.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.pq.setLocalStorage('pqUserInfo', res.data);
                    window.pq.setLocalStorage('pqToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  } else if (res.code === 10101106) {
                    window.pq.openAccountDrawer('change-password');
                    document.querySelector('pq-account-change-password').setAttribute('data-sign', res.data.sign);
                    document.querySelector('pq-account-change-password').setAttribute('data-email', emailValue);
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('login error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          // 注册接口
          async login(data) {
            const url = '/shopify/auth/login';
            const res = await window.pq.http.post(url, {
              data: {
                ...data,
              },
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101106) {
              return res;
            } else if (res.code === 10101102) {
              throw new Error(window.pqI18n.error_10101102);
            } else if (res.code === 10101105) {
              throw new Error(window.pqI18n.error_10101105);
            } else if (res.code === 10101109) {
              throw new Error(window.pqI18n.error_10101109_login);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          async fetchRsa() {
            const url = '/shopify/auth/rsa';
            const { data } = await window.pq.http.get(url);
            this.rsa = data.publicKey;
          }
          initPasswordEye() {
            const passwordContainers = this.querySelector('[data-type="password"]');
            const input = passwordContainers.querySelector('.pq-custom-form-container-input');
            const eyeCloseDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-close');
            const eyeOpenDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-open');
            // 点击后修改data-plaintext属性
            eyeCloseDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'true');
              input.setAttribute('type', 'text');
            });
            eyeOpenDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'false');
              input.setAttribute('type', 'password');
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-quick-login"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-quick-login')) {
      customElements.define(
        'pq-account-quick-login',
        class PqAccountQuickLogin extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            // fb打开弹窗后加载
            // this.initFBLogin();
            this.initGoogleLogin();
            if (this.getAttribute('data-template') === 'login' || this.getAttribute('data-template') === 'register') {
              this.initFBLogin();
              window.pq.loadQuickLoginStatus = true;
            }
          }
          initFBLogin() {
            const _this = this;
            window.checkLoginState = function () {
              FB.getLoginStatus(async function (response) {
                if (response.status === 'connected') {
                  await _this.handleFBLogin(response);
                } else {
                }
              });
            };

            // 在 facebook-google-login.js 中添加
            window.handleFacebookLogin = function () {
              FB.login(
                function (response) {
                  if (response.authResponse) {
                    // 登录成功，获取用户信息
                    FB.api('/me', { fields: 'name,email,picture' }, function (userInfo) {
                      console.log('Facebook 用户信息:', userInfo);
                      // 调用你的登录处理函数
                      window.checkLoginState();
                    });
                  } else {
                    console.log('用户取消登录或未授权');
                    // window.pqToast.showToast('error', window.pqI18n.cancel_login);
                  }
                },
                { scope: 'public_profile,email' }
              );
            };

            // 修改 Facebook 初始化代码
            window.fbAsyncInit = function () {
              FB.init({
                appId: '713881260996325',
                cookie: true,
                xfbml: true,
                version: 'v22.0',
              });

              // 检查登录状态
              FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                  console.log('已登录 Facebook');
                }
              });
            };
            // 检查 SDK 是否已加载
            function checkFBLoaded() {
              if (window.FB) {
                console.log('window.FB window.FB');
                window.fbAsyncInit();
              } else {
                setTimeout(checkFBLoaded, 100);
              }
            }

            checkFBLoaded();
          }
          initGoogleLogin() {
            const _this = this;
            window.handleGoogleLogin = function (resp) {
              if (window.customer) return;
              _this.handleGoogleLogin(resp);
            };
          }
          // 第三方登录
          async handleFBLogin(resp) {
            const url = '/oauth/login';
            const urlParams = new URLSearchParams(window.location.search);
            let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
            if (redirectUrl === '/') {
              if (window.location.href.includes('/login') || window.location.href.includes('/register')) {
                redirectUrl = window.location.origin;
              } else {
                redirectUrl = window.location.href;
              }
            } else {
              redirectUrl = window.location.origin + redirectUrl;
            }
            const res = await window.pq.http.post(url, {
              data: {
                type: 4,
                credential: resp.authResponse.accessToken,
                returnTo: redirectUrl,
              },
            });
            if (res.code === 200) {
              window.pq.closeAccountDrawer();
              window.pqToast.showToast('success', window.pqI18n.common_welcome_back);
              window.pq.setLocalStorage('pqUserInfo', res.data);
              window.pq.setLocalStorage('pqToken', res.data.token);
              window.location.href = res.data.mutilpass;
            } else if (res.code === 10101102) {
              window.pqToast.showToast('error', window.pqI18n.error_10101102);
            } else if (res.code === 10101105) {
              window.pqToast.showToast('error', window.pqI18n.error_10101105);
            } else if (res.code === 10101109) {
              window.pqToast.showToast('error', window.pqI18n.error_10101109);
            } else {
              window.pqToast.showToast('error', window.pqI18n.error_request_failed);
            }
          }
          async handleGoogleLogin(resp) {
            const url = '/oauth/login';
            const urlParams = new URLSearchParams(window.location.search);
            let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
            if (redirectUrl === '/') {
              if (window.location.href.includes('/login') || window.location.href.includes('/register')) {
                redirectUrl = window.location.origin;
              } else {
                redirectUrl = window.location.href;
              }
            } else {
              redirectUrl = window.location.origin + redirectUrl;
            }
            const res = await window.pq.http.post(url, {
              data: {
                type: 2,
                credential: resp.credential,
                returnTo: redirectUrl,
              },
            });
            if (res.code === 200) {
              window.pq.closeAccountDrawer();
              window.pqToast.showToast('success', window.pqI18n.common_welcome_back);
              window.pq.setLocalStorage('pqUserInfo', res.data);
              window.pq.setLocalStorage('pqToken', res.data.token);

              window.location.href = res.data.mutilpass;
            } else if (res.code === 10101102) {
              window.pqToast.showToast('error', window.pqI18n.error_10101102);
            } else if (res.code === 10101105) {
              window.pqToast.showToast('error', window.pqI18n.error_10101105);
            } else if (res.code === 10101109) {
              window.pqToast.showToast('error', window.pqI18n.error_10101109);
            } else {
              window.pqToast.showToast('error', window.pqI18n.error_request_failed);
            }
          }
        }
      );
    }
  });

  window.addEventListener('load', function () {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    document.head.appendChild(script);
    script.onload = function () {
      const isLoggedIn = Boolean(window.customer); // 假设 Shopify 登录后 window.customer 有值

      google.accounts.id.initialize({
        client_id: '203322924039-qfb76akdu69crim6crhvn2arutu2nflh.apps.googleusercontent.com',
        callback: handleGoogleLogin,
        ux_mode: 'popup',
        auto_select: false,
        cancel_on_tap_outside: false, // 添加这行
        context: 'signin', // 添加这行
      });

      // 初始化按钮（不论是否已登录都显示按钮）
      const googleButtonPlaceholders = document.querySelectorAll('.google-button-placeholder');
      googleButtonPlaceholders.forEach((placeholder) => {
        google.accounts.id.renderButton(placeholder, {
          theme: 'outline',
          size: 'medium',
          type: 'standard',
        });
      });

      // 控制是否显示 One Tap
      if (!isLoggedIn) {
        setTimeout(() => {
          const isLoginOut = window.pq.getLocalStorage('pq-login_out') || 0;
          const nowTime = new Date().getTime();
          if (nowTime - isLoginOut > 1000 * 60 * 30) {
            google.accounts.id.prompt(); // 显示 One Tap 弹窗
          }
        }, 1000);
      } else {
        // 显式禁止 One Tap 弹窗再次出现
        if (google) {
          google.accounts.id.disableAutoSelect();
          google.accounts.id.cancel();
        }
      }
    };
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-register"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-register')) {
      customElements.define(
        'pq-account-register',
        class PqAccountRegister extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initSubscribe();
            this.initForm();
            this.submitForm();
            this.initPasswordEye();
          }
          // 订阅初始化
          initSubscribe() {
            const subscribe = this.querySelector('[data-type="subscribe"]');
            if (subscribe) {
              subscribe.addEventListener('click', (e) => {
                e.preventDefault();
                subscribe.setAttribute(
                  'data-checked',
                  subscribe.getAttribute('data-checked') === 'true' ? 'false' : 'true'
                );
              });
            }
          }
          // 表单初始化
          initForm() {
            // 邮箱校验 防抖处理
            const email = this.querySelector('[data-type="email"]');
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            if (email && emailInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedEmailValidate = window.pq.debounce((value) => {
                this.validate('email', email, value);
              }, 300);

              emailInput.addEventListener('input', (e) => {
                const value = e.target.value.trim();
                debouncedEmailValidate(value);
              });
            }

            // 密码校验 防抖处理
            const password = this.querySelector('[data-type="password"]');
            const passwordInput =
              password?.querySelector('.pq-custom-form-container-input-wrapper .pq-custom-form-container-input') ||
              password?.querySelector('.pq-custom-form-container-input');
            if (password && passwordInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordValidate = window.pq.debounce((value) => {
                this.validate('password', password, value);
              }, 300);

              passwordInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordValidate(value);
              });
            }
          }
          // 校验逻辑
          validate(type, container, value) {
            if (!container) {
              return;
            }

            let regular = null;
            switch (type) {
              case 'email':
                regular = window.pq?.rule?.email;
                break;
              case 'password':
                regular = window.pq?.rule?.password;
                break;
              default:
                break;
            }

            if (!regular) {
              console.warn(`验证规则未找到: ${type}`);
              return;
            }

            const isValid = regular.test(value);
            // 为空也显示错误
            container.setAttribute('data-error', isValid && value ? 'false' : 'true');
          }
          // 提交表单
          submitForm() {
            const button = this.querySelector('.pq-account-register__submit');
            if (button) {
              button.addEventListener('click', async (e) => {
                e.preventDefault();
                const email = this.querySelector('[data-type="email"]');
                const password = this.querySelector('[data-type="password"]');
                const subscribe = this.querySelector('[data-type="subscribe"]');
                // 同时执行一遍校验
                this.validate('email', email, email.querySelector('.pq-custom-form-container-input').value);
                this.validate('password', password, password.querySelector('.pq-custom-form-container-input').value);
                if (email.getAttribute('data-error') === 'true' || password.getAttribute('data-error') === 'true') {
                  return;
                }
                try {
                  button.setAttribute('data-loading', 'true');
                  const urlParams = new URLSearchParams(window.location.search);
                  let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
                  if (redirectUrl === '/') {
                    if (window.location.href.includes('/register')) {
                      redirectUrl = window.location.origin;
                    } else {
                      redirectUrl = window.location.href;
                    }
                  } else {
                    redirectUrl = window.location.origin + redirectUrl;
                  }
                  if (!this.rsa) {
                    await this.fetchRsa();
                  }
                  const encryptedPassword = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    password.querySelector('.pq-custom-form-container-input').value
                  );
                  const data = {
                    email: email.querySelector('.pq-custom-form-container-input').value,
                    password: encryptedPassword,
                    acceptsMarketing: subscribe.getAttribute('data-checked') === 'true' ? 1 : 0,
                    returnTo: redirectUrl,
                  };
                  if (this.getAttribute('data-payload')) {
                    let payload = JSON.parse(this.getAttribute('data-payload'));
                    if (payload && payload.source === 'CollectionLottery') {
                      data.source = 11;
                      data.marketingCampaignId = payload.marketingCampaignId;
                    }
                  }
                  const res = await this.register(data);
                  if (res.code === 200) {
                    window.pq.closeAccountDrawer();
                    window.pqToast.showToast('success', window.pqI18n.common_welcome_back);
                    if (res.data?.referralInvitedReward) {
                      window.pq.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.pq.setLocalStorage('pqUserInfo', res.data);
                    window.pq.setLocalStorage('pqToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('register error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          // 注册接口
          async register(data) {
            console.log('register', data);
            const url = '/shopify/auth/register';
            const res = await window.pq.http.post(url, {
              data: {
                ...data,
              },
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101404) {
              throw new Error(window.pqI18n.error_10101404);
            } else if (res.code === 10101109) {
              throw new Error(window.pqI18n.error_10101109);
            } else {
              console.error('register error', res);
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          async fetchRsa() {
            const url = '/shopify/auth/rsa';
            const { data } = await window.pq.http.get(url);
            this.rsa = data.publicKey;
          }

          initPasswordEye() {
            const passwordContainers = this.querySelector('[data-type="password"]');
            const input = passwordContainers.querySelector('.pq-custom-form-container-input');
            const eyeCloseDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-close');
            const eyeOpenDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-open');
            // 点击后修改data-plaintext属性
            eyeCloseDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'true');
              input.setAttribute('type', 'text');
            });
            eyeOpenDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'false');
              input.setAttribute('type', 'password');
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-reset-password"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-reset-password')) {
      customElements.define(
        'pq-account-reset-password',
        class PqAccountResetPassword extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initData();
            this.initForm();
            this.submitForm();
            this.initPasswordEye();
          }
          initData() {
            const urlParams = new URLSearchParams(window.location.search);
            const email = this.querySelector('[data-type="email"]');
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            // 获取路径中的email邮箱
            const type = urlParams.get('type');
            if (type === 'reset') {
              const emailValue = urlParams.get('email');
              const signValue = urlParams.get('sign');
              if (emailValue) {
                emailInput.value = emailValue;
              }
              this.sign = signValue;
              this.email = emailValue;
              // 移除路径中的email和sign参数
              window.history.replaceState({}, '', window.location.pathname);
            }
          }
          // 表单初始化
          initForm() {
            // 邮箱校验 防抖处理
            const email = this.querySelector('[data-type="email"]');
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            if (email && emailInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedEmailValidate = window.pq.debounce((value) => {
                this.validate('email', email, value);
              }, 300);

              emailInput.addEventListener('input', (e) => {
                const value = e.target.value.trim();
                debouncedEmailValidate(value);
              });
            }

            // 密码校验 防抖处理
            const password = this.querySelector('[data-type="password"]');
            const passwordInput =
              password?.querySelector('.pq-custom-form-container-input-wrapper .pq-custom-form-container-input') ||
              password?.querySelector('.pq-custom-form-container-input');
            if (password && passwordInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordValidate = window.pq.debounce((value) => {
                this.validate('password', password, value);
              }, 300);

              passwordInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordValidate(value);
              });
            }
            // 确认密码校验 防抖处理
            const passwordConfirmation = this.querySelector('[data-type="password_confirmation"]');
            const passwordConfirmationInput = passwordConfirmation?.querySelector('.pq-custom-form-container-input');
            if (passwordConfirmation && passwordConfirmationInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordConfirmationValidate = window.pq.debounce((value) => {
                this.validate('password_confirmation', passwordConfirmation, value);
              }, 300);
              passwordConfirmationInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordConfirmationValidate(value);
              });
            }
          }
          // 校验逻辑
          validate(type, container, value) {
            if (!container) {
              return;
            }

            let regular = null;
            switch (type) {
              case 'email':
                regular = window.pq?.rule?.email;
                break;
              case 'password':
                regular = window.pq?.rule?.password;
                break;
              case 'password_confirmation':
                regular = window.pq?.rule?.password;
                break;
              default:
                break;
            }

            if (!regular) {
              console.warn(`验证规则未找到: ${type}`);
              return;
            }

            const isValid = regular.test(value);
            // 为空也显示错误
            container.setAttribute('data-error', isValid && value ? 'false' : 'true');
          }
          // 提交表单
          submitForm() {
            const button = this.querySelector('.pq-account-reset-password__submit');
            if (button) {
              button.addEventListener('click', async (e) => {
                e.preventDefault();
                const email = this.querySelector('[data-type="email"]');
                const password = this.querySelector('[data-type="password"]');
                const passwordConfirmation = this.querySelector('[data-type="password_confirmation"]');
                // 同时执行一遍校验
                this.validate('email', email, email.querySelector('.pq-custom-form-container-input').value);
                this.validate('password', password, password.querySelector('.pq-custom-form-container-input').value);
                this.validate(
                  'password_confirmation',
                  passwordConfirmation,
                  passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                );
                if (
                  email.getAttribute('data-error') === 'true' ||
                  password.getAttribute('data-error') === 'true' ||
                  passwordConfirmation.getAttribute('data-error') === 'true'
                ) {
                  return;
                }
                if (
                  password.querySelector('.pq-custom-form-container-input').value !==
                  passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                ) {
                  window.pqToast.showToast('error', window.pqI18n.error_10101416);
                  return;
                }
                try {
                  button.setAttribute('data-loading', 'true');
                  if (!this.rsa) {
                    await this.fetchRsa();
                  }
                  const encryptedPassword = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    password.querySelector('.pq-custom-form-container-input').value
                  );
                  const encryptedPasswordConfirmation = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                  );
                  const data = {
                    email: email.querySelector('.pq-custom-form-container-input').value,
                    password: encryptedPassword,
                    confirmPassword: encryptedPasswordConfirmation,
                    sign: this.sign,
                  };
                  const res = await this.forgotPassword(data);
                  if (res.code === 200) {
                    window.pq.closeAccountDrawer();
                    window.pqToast.showToast('success', window.pqI18n.reset_password_success);
                    if (res.data?.referralInvitedReward) {
                      window.pq.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.pq.setLocalStorage('pqUserInfo', res.data);
                    window.pq.setLocalStorage('pqToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('login error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          async forgotPassword(data) {
            const url = '/shopify/auth/forget';
            const res = await window.pq.http.post(url, {
              data,
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101109) {
              throw new Error(window.pqI18n.error_10101109);
            } else if (res.code === 10101107) {
              throw new Error(window.pqI18n.error_10101107);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          async fetchRsa() {
            const url = '/shopify/auth/rsa';
            const { data } = await window.pq.http.get(url);
            this.rsa = data.publicKey;
          }
          initPasswordEye() {
            const passwordContainers = this.querySelector('[data-type="password"]');
            const input = passwordContainers.querySelector('.pq-custom-form-container-input');
            const eyeCloseDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-close');
            const eyeOpenDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-open');
            // 点击后修改data-plaintext属性
            eyeCloseDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'true');
              input.setAttribute('type', 'text');
            });
            eyeOpenDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'false');
              input.setAttribute('type', 'password');
            });
            // 确认密码
            const passwordConfirmationContainers = this.querySelector('[data-type="password_confirmation"]');
            const passwordConfirmationInput = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input'
            );
            const passwordConfirmationEyeCloseDom = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input-icon-close'
            );
            const passwordConfirmationEyeOpenDom = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input-icon-open'
            );
            // 点击后修改data-plaintext属性
            passwordConfirmationEyeCloseDom.addEventListener('click', () => {
              passwordConfirmationContainers.setAttribute('data-plaintext', 'true');
              passwordConfirmationInput.setAttribute('type', 'text');
            });
            passwordConfirmationEyeOpenDom.addEventListener('click', () => {
              passwordConfirmationContainers.setAttribute('data-plaintext', 'false');
              passwordConfirmationInput.setAttribute('type', 'password');
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-account-setup-password"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-setup-password')) {
      customElements.define(
        'pq-account-setup-password',
        class PqAccountSetupPassword extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          static get observedAttributes() {
            return ['data-type'];
          }
          attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-type') {
              this.initType(newValue);
            }
          }
          init() {
            this.setAttribute('data-type', 'default');
            this.initData();
            this.initForm();
            this.submitForm();
            this.initPasswordEye();
            this.initInvalid();
          }
          initInvalid() {
            const pqAccountSetupPasswordInvalidContentContact = this.querySelector(
              '.pq-account-setup-password__invalid-content-contact'
            );
            if (pqAccountSetupPasswordInvalidContentContact) {
              pqAccountSetupPasswordInvalidContentContact.addEventListener('click', (e) => {
                window.pq.openChatApp();
              });
            }
          }
          initType(type) {
            const pqAccountSetupPasswordDefault = this.querySelector('.pq-account-setup-password__default');
            const pqAccountSetupPasswordInvalid = this.querySelector('.pq-account-setup-password__invalid');
            if (type === 'default') {
              pqAccountSetupPasswordDefault.classList.add('active');
              pqAccountSetupPasswordInvalid.classList.remove('active');
            } else if (type === 'invalid') {
              pqAccountSetupPasswordDefault.classList.remove('active');
              pqAccountSetupPasswordInvalid.classList.add('active');
            }
          }
          initData() {
            const urlParams = new URLSearchParams(window.location.search);
            const email = this.querySelector('[data-type="email"]');
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            // 获取路径中的email邮箱
            const type = urlParams.get('type');
            if (type === 'setup') {
              const emailValue = urlParams.get('email');
              const signValue = urlParams.get('sign');
              if (emailValue) {
                emailInput.value = emailValue;
              }
              this.sign = signValue;
              this.email = emailValue;
              // 移除路径中的email和sign参数
                window.history.replaceState({}, '', window.location.pathname);
            }
          }
          // 表单初始化
          initForm() {
            // 邮箱校验 防抖处理
            const email = this.querySelector('[data-type="email"]');
            const emailInput = email?.querySelector('.pq-custom-form-container-input');
            if (email && emailInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedEmailValidate = window.pq.debounce((value) => {
                this.validate('email', email, value);
              }, 300);

              emailInput.addEventListener('input', (e) => {
                const value = e.target.value.trim();
                debouncedEmailValidate(value);
              });
            }

            // 密码校验 防抖处理
            const password = this.querySelector('[data-type="password"]');
            const passwordInput =
              password?.querySelector('.pq-custom-form-container-input-wrapper .pq-custom-form-container-input') ||
              password?.querySelector('.pq-custom-form-container-input');
            if (password && passwordInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordValidate = window.pq.debounce((value) => {
                this.validate('password', password, value);
              }, 300);

              passwordInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordValidate(value);
              });
            }
            // 确认密码校验 防抖处理
            const passwordConfirmation = this.querySelector('[data-type="password_confirmation"]');
            const passwordConfirmationInput = passwordConfirmation?.querySelector('.pq-custom-form-container-input');
            if (passwordConfirmation && passwordConfirmationInput) {
              // 创建防抖函数，确保防抖生效
              const debouncedPasswordConfirmationValidate = window.pq.debounce((value) => {
                this.validate('password_confirmation', passwordConfirmation, value);
              }, 300);
              passwordConfirmationInput.addEventListener('input', (e) => {
                const value = e.target.value;
                debouncedPasswordConfirmationValidate(value);
              });
            }
          }
          // 校验逻辑
          validate(type, container, value) {
            if (!container) {
              return;
            }

            let regular = null;
            switch (type) {
              case 'email':
                regular = window.pq?.rule?.email;
                break;
              case 'password':
                regular = window.pq?.rule?.password;
                break;
              case 'password_confirmation':
                regular = window.pq?.rule?.password;
                break;
              default:
                break;
            }

            if (!regular) {
              console.warn(`验证规则未找到: ${type}`);
              return;
            }

            const isValid = regular.test(value);
            // 为空也显示错误
            container.setAttribute('data-error', isValid && value ? 'false' : 'true');
          }
          // 提交表单
          submitForm() {
            const button = this.querySelector('.pq-account-setup-password__submit');
            if (button) {
              button.addEventListener('click', async (e) => {
                e.preventDefault();
                const email = this.querySelector('[data-type="email"]');
                const password = this.querySelector('[data-type="password"]');
                const passwordConfirmation = this.querySelector('[data-type="password_confirmation"]');
                // 同时执行一遍校验
                this.validate('email', email, email.querySelector('.pq-custom-form-container-input').value);
                this.validate('password', password, password.querySelector('.pq-custom-form-container-input').value);
                this.validate(
                  'password_confirmation',
                  passwordConfirmation,
                  passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                );
                if (
                  email.getAttribute('data-error') === 'true' ||
                  password.getAttribute('data-error') === 'true' ||
                  passwordConfirmation.getAttribute('data-error') === 'true'
                ) {
                  return;
                }
                if (
                  password.querySelector('.pq-custom-form-container-input').value !==
                  passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                ) {
                  window.pqToast.showToast('error', window.pqI18n.error_10101416);
                  return;
                }
                try {
                  button.setAttribute('data-loading', 'true');
                  if (!this.rsa) {
                    await this.fetchRsa();
                  }
                  const encryptedPassword = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    password.querySelector('.pq-custom-form-container-input').value
                  );
                  const encryptedPasswordConfirmation = window.pq.rsaEncryptWithCrypto(
                    this.rsa,
                    passwordConfirmation.querySelector('.pq-custom-form-container-input').value
                  );
                  const data = {
                    email: email.querySelector('.pq-custom-form-container-input').value,
                    password: encryptedPassword,
                    confirmPassword: encryptedPasswordConfirmation,
                    sign: this.sign,
                  };
                  const res = await this.setupPassword(data);
                  if (res.code === 200) {
                    window.pq.closeAccountDrawer();
                    window.pqToast.showToast('success', window.pqI18n.setup_password_success);
                    if (res.data?.referralInvitedReward) {
                      window.pq.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.pq.setLocalStorage('pqUserInfo', res.data);
                    window.pq.setLocalStorage('pqToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('login error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          async setupPassword(data) {
            const url = '/shopify/auth/invite';
            const res = await window.pq.http.post(url, {
              data,
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101110) {
              throw new Error(window.pqI18n.error_10101404);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          async fetchRsa() {
            const url = '/shopify/auth/rsa';
            const { data } = await window.pq.http.get(url);
            this.rsa = data.publicKey;
          }
          initPasswordEye() {
            const passwordContainers = this.querySelector('[data-type="password"]');
            const input = passwordContainers.querySelector('.pq-custom-form-container-input');
            const eyeCloseDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-close');
            const eyeOpenDom = passwordContainers.querySelector('.pq-custom-form-container-input-icon-open');
            // 点击后修改data-plaintext属性
            eyeCloseDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'true');
              input.setAttribute('type', 'text');
            });
            eyeOpenDom.addEventListener('click', () => {
              passwordContainers.setAttribute('data-plaintext', 'false');
              input.setAttribute('type', 'password');
            });
            // 确认密码
            const passwordConfirmationContainers = this.querySelector('[data-type="password_confirmation"]');
            const passwordConfirmationInput = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input'
            );
            const passwordConfirmationEyeCloseDom = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input-icon-close'
            );
            const passwordConfirmationEyeOpenDom = passwordConfirmationContainers.querySelector(
              '.pq-custom-form-container-input-icon-open'
            );
            // 点击后修改data-plaintext属性
            passwordConfirmationEyeCloseDom.addEventListener('click', () => {
              passwordConfirmationContainers.setAttribute('data-plaintext', 'true');
              passwordConfirmationInput.setAttribute('type', 'text');
            });
            passwordConfirmationEyeOpenDom.addEventListener('click', () => {
              passwordConfirmationContainers.setAttribute('data-plaintext', 'false');
              passwordConfirmationInput.setAttribute('type', 'password');
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-header-account"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-header-account')) {
      customElements.define(
        'pq-header-account',
        class PqHeaderAccount extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            console.log('pq-header-account connected');
            this.init();
          }
          init() {
            this.initAccount();
            this.initOpenDrawer();
            this.initLogout();
          }
          initAccount() {
            console.log('pq-header-account init');
            const pqHeaderAccountIcon = document.querySelector('.pq-header-account-icon');
            const pqHeaderAccount = document.querySelector('pq-header-account');
            if (pqHeaderAccountIcon) {
              pqHeaderAccountIcon.addEventListener('click', (e) => {
                // 阻止a标签的默认行为
                e.preventDefault();
                this.setAttribute('data-show', 'true');
              });
              // 增加鼠标移入事件
              pqHeaderAccountIcon.addEventListener('mouseenter', () => {
                this.setAttribute('data-show', 'true');
              });
              // 增加鼠标移出事件
              pqHeaderAccountIcon.addEventListener('mouseleave', () => {
                this.setAttribute('data-show', 'false');
              });
            }
            if (pqHeaderAccount) {
              pqHeaderAccount.addEventListener('mouseenter', () => {
                this.setAttribute('data-show', 'true');
              });
              pqHeaderAccount.addEventListener('mouseleave', () => {
                this.setAttribute('data-show', 'false');
              });
            }
          }
          initOpenDrawer() {
            const pqHeaderAccountNotLoginHandleJoin = document.querySelector(
              '.pq-header-account__not-login-handle-join'
            );
            if (pqHeaderAccountNotLoginHandleJoin) {
              pqHeaderAccountNotLoginHandleJoin.addEventListener('click', () => {
                window.pq.openAccountDrawer('login-register', 'register');
                this.setAttribute('data-show', 'false');
              });
            }
            const pqHeaderAccountNotLoginHandleLogin = document.querySelector(
              '.pq-header-account__not-login-handle-login'
            );
            if (pqHeaderAccountNotLoginHandleLogin) {
              pqHeaderAccountNotLoginHandleLogin.addEventListener('click', () => {
                window.pq.openAccountDrawer('login-register', 'login');
                this.setAttribute('data-show', 'false');
              });
            }
          }
          initLogout() {
            const pqHeaderAccountLoginHandleItemLogout = this.querySelector(
              '.pq-header-account__login-handle-item-logout'
            );

            if (pqHeaderAccountLoginHandleItemLogout) {
              const href = pqHeaderAccountLoginHandleItemLogout?.getAttribute('href');
              pqHeaderAccountLoginHandleItemLogout.addEventListener('click', (e) => {
                e.preventDefault();
                if (FB) {
                  // 获取Facebook登录状态
                  FB.getLoginStatus(function (response) {
                    if (response.status === 'connected') {
                      // 登出Facebook
                      FB.logout();
                    }
                  });
                }
                window.pq.setLocalStorage('pq-login_out', new Date().getTime());
                window.location.href = href;
              });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-header-switch-site"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('pq-header-switch-site')) {
      customElements.define(
        'pq-header-switch-site',
        class PqHeaderSwitchSite extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initData();
            this.initClose();
            this.initConfirm();
            this.initCancel();
            this.initRedirect();
          }
          initConfirm() {
            const button = this.querySelector('.pq-header-switch-site__handle-confirm');
            if (button) {
              button.addEventListener('click', async (e) => {
                try {
                  button.setAttribute('data-loading', 'true');
                  const data = {
                    sign: this.sign,
                  };
                  const res = await this.changeShopInfo(data);
                  if (res.code === 200) {
                    this.setAttribute('data-show', 'false');
                    window.pqToast.showToast('success', window.pqI18n.common_welcome_back);
                    if (res.data?.referralInvitedReward) {
                      window.pq.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.pq.setLocalStorage('pqUserInfo', res.data);
                    window.pq.setLocalStorage('pqToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  }
                } catch (error) {
                  window.pqToast.showToast('error', error.message);
                  console.error('login error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          // 切换店铺后获取用户信息
          async changeShopInfo(data) {
            const url = '/shopify/auth/change/shop/info';
            const res = await window.pq.http.get(url, {
              data: {
                ...data,
              },
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101102) {
              throw new Error(window.pqI18n.error_10101102);
            } else if (res.code === 10101105) {
              throw new Error(window.pqI18n.error_10101105);
            } else if (res.code === 10101109) {
              throw new Error(window.pqI18n.error_10101109);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          initCancel() {
            const cancel = this.querySelector('.pq-header-switch-site__handle-cancel');
            cancel.addEventListener('click', () => {
              window.pq.openAccountDrawer('login-register', 'register');
              this.setAttribute('data-show', 'false');
            });
          }
          initClose() {
            const close = this.querySelector('.pq-header-switch-site__content-close');
            close.addEventListener('click', () => {
              this.setAttribute('data-show', 'false');
            });
          }
          initData() {
            console.log('pq-header-switch-site initData');
            const urlParams = new URLSearchParams(window.location.search);
            const email = this.querySelector('.pq-header-switch-site__content-text-email');
            // 获取路径中的email邮箱
            const type = urlParams.get('type');
            if (type === 'changeShop') {
              if (!window.customer) {
                const emailValue = urlParams.get('email');
                const signValue = urlParams.get('sign');
                if (emailValue) {
                  email.textContent = emailValue;
                }
                this.sign = signValue;
                this.setAttribute('data-show', 'true');
                this.initShow();
              }
              // 移除路径中的email和sign参数
              window.history.replaceState({}, '', window.location.pathname);
            }
          }
          initShow() {
            // 设置五秒后关闭，鼠标移入暂停关闭，鼠标移出重新计时关闭
            let timer = setTimeout(() => {
              this.setAttribute('data-show', 'false');
            }, 5000);
            this.addEventListener('mouseenter', () => {
              clearTimeout(timer);
            });
            this.addEventListener('mouseleave', () => {
              timer = setTimeout(() => {
                this.setAttribute('data-show', 'false');
              }, 5000);
            });
          }
          initRedirect() {
            console.log(window.customer, window.pq.getLocalStorage('pqToken'));
            if (window.customer && window.pq.getLocalStorage('pqToken')) {
              const switchSiteLink = document.querySelectorAll('[data-action="switch-site"]');
              switchSiteLink.forEach((link) => {
                link.addEventListener('click', async (e) => {
                  e.preventDefault();
                  try {
                    // 完整的域名，带上https://
                    const domain = link.href;
                    // const domain = 'https://dev-askstarry.myshopify.com/';
                    const data = {
                      domain: domain,
                    };
                    const res = await this.getMutilpass(data);
                    if (res.code === 200) {
                      window.location.href = res.data.mutilpass;
                    }
                  } catch (error) {
                    window.location.href = link.href;
                  }
                });
              });
            }
          }
          // 切换店铺获取mutilpass
          async getMutilpass(data) {
            const url = '/shopify/auth/change/shop';
            const res = await window.pq.http.get(url, {
              data: {
                ...data,
              },
            });
            if (res.code === 200) {
              return res;
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-mobile-country-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-mobile-country-selector')) {
      customElements.define(
        'pq-mobile-country-selector',
        class PqMobileCountrySelector extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initPanel();
          }
          initPanel() {
            const trigger = this.querySelector('.pq-mobile-country-selector__trigger');
            const panel = this.querySelector('.pq-mobile-country-selector__panel');
            trigger.addEventListener('click', () => {
              if (trigger.getAttribute('data-expanded') === 'true') {
                panel.style.height = '0';
                trigger.setAttribute('data-expanded', 'false');
              } else {
                panel.style.height = panel.scrollHeight + 'px';
                trigger.setAttribute('data-expanded', 'true');
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-product-content-countdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('pq-product-content-countdown')) {
      customElements.define(
        'pq-product-content-countdown',
        class PqProductContentCountdown extends HTMLElement {
          constructor() {
            super();
            this.countdownInterval = null;
            this.timeRemaining = 0; // 内部剩余时间（毫秒）
            this.isFixedMode = false; // 是否为固定时长模式
          }

          connectedCallback() {
            this.initCountdown();
          }

          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }
          }

          initCountdown() {
            const startTsStr = this.getAttribute('data-start');
            const endTsStr = this.getAttribute('data-end');

            if (!endTsStr || endTsStr === '') return;

            const startTime = startTsStr !== '' ? parseInt(startTsStr) * 1000 : null;
            const endTime = parseInt(endTsStr) * 1000;
            const now = Date.now();

            // 逻辑判断：
            if (startTime) {
              // 模式 A：固定时长模式 (结束时间 - 开始时间)
              // 只有当现在时间 >= 开始时间，且 <= 结束时间时才显示
              if (now >= startTime && now <= endTime) {
                this.isFixedMode = true;
                this.timeRemaining = endTime - startTime; // 固定为设置的差值
                this.style.display = 'block';
              } else {
                this.style.display = 'none';
                return;
              }
            } else {
              // 模式 B：实时模式 (结束时间 - 现在时间)
              if (now <= endTime) {
                this.isFixedMode = false;
                this.timeRemaining = endTime - now;
                this.style.display = 'block';
              } else {
                this.style.display = 'none';
                return;
              }
            }

            this.renderTime(this.timeRemaining);
            this.startTimer();
          }

          startTimer() {
            this.countdownInterval = setInterval(() => {
              const endTsStr = this.getAttribute('data-end');
              const startTsStr = this.getAttribute('data-start');

              const now = Date.now();
              const startTime = startTsStr ? parseInt(startTsStr) * 1000 : null;
              const endTime = parseInt(endTsStr) * 1000;

              if (startTime && now < startTime) {
                this.timeRemaining = startTime - now;
              } else if (now <= endTime) {
                this.timeRemaining = endTime - now;
              } else {
                this.timeRemaining = 0;
                this.renderTime(0);
                this.style.display = 'none';
                clearInterval(this.countdownInterval);
                return;
              }

              this.renderTime(this.timeRemaining);
            }, 1000);
          }

          renderTime(diff) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysElement = this.querySelector('.days');
            const hoursElement = this.querySelector('.hrs');
            const minutesElement = this.querySelector('.min');
            const secondsElement = this.querySelector('.sec');

            if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
            if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
            if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
            if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-product-content-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('pq-product-content-product-set')) {
      customElements.define(
        'pq-product-content-product-set',
        class RoProductContentProductSet extends HTMLElement {
          constructor() {
            super();
            this.selectedOption = null;
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.options = this.querySelectorAll('.pq-product-content-product-set__option');
            this.bindEvents();

            // 监听页面可见性变化（移动端返回页面时触发）
            document.addEventListener('visibilitychange', () => {
              if (!document.hidden) {
                this.setInitialSelection();
              }
            });

            // 监听 pageshow 事件（捕获浏览器前进/返回操作）
            window.addEventListener('pageshow', (e) => {
              if (e.persisted) {
                // 从 bfcache 返回，重新初始化
                this.setInitialSelection();
              }
            });

            this.setInitialSelection();
          }

          bindEvents() {
            // 点击选项
            this.options.forEach((option) => {
              option.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectOption(option);
              });
            });
          }

          setInitialSelection() {
            // 通过当前页面 URL 匹配选项
            const currentPath = window.location.pathname;
            const currentOption = Array.from(this.options).find((opt) => {
              try {
                const optionUrl = new URL(opt.href, window.location.origin);
                return optionUrl.pathname === currentPath;
              } catch (e) {
                // 如果 href 是相对路径，直接比较
                return opt.getAttribute('href') === currentPath;
              }
            });

            if (currentOption) {
              this.selectOption(currentOption, false);
            } else {
              // 如果没有找到匹配的，保持第一个选中状态
              const selectedOption = this.querySelector('.pq-product-content-product-set__option.selected');
              if (selectedOption) {
                this.selectedOption = selectedOption;
              }
            }
          }

          selectOption(option, navigate = true) {
            // 移除之前的选中状态
            this.options.forEach((opt) => opt.classList.remove('selected'));

            // 设置新的选中状态
            option.classList.add('selected');
            this.selectedOption = option;

            // 如果需要导航，跳转到产品页面
            if (navigate && option.href) {
              window.location.href = option.href;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

})();
